(function () {

/*
 Die Maske ist für alle Motive dieselbe. Alles Motivspezifische steht in vorlagen/<name>.json (Titel, Motivbild,
 Schrift, Namensfelder mit Platzierungsregel, Posterpreise), alles Shopweite in vorlagen/gemeinsam.json (Rahmen,
 Passepartout, Zubehör). Welche Vorlage geladen wird, bestimmt ?vorlage=<name> in der Adresse.
 Die Maske setzt Poster im DIN-Hochformat voraus (Seitenverhältnisse von Rahmen und Kacheln im CSS).
*/
/*
 Umgebung. Im Prototyp läuft die Maske direkt in der Seite. Im Shop steckt sie in einem abgeschirmten Bereich
 (Shadow DOM), damit sich ihre Gestaltung und die des Themes nicht gegenseitig stören. Das Theme übergibt dann in
 window.JUHMI_CZ: root (der abgeschirmte Bereich), vorlage (Name der Vorlage), asset (Adresse einer Datei im Theme),
 data (Vorlagen und Tabellen, schon geladen), currentSize (gewählte Größe der Produktseite), onAdd (Warenkorb).
*/
const ENV = window.JUHMI_CZ || {};
const ROOT = ENV.root || document;
const asset = ENV.asset || ((path) => path);
const TEMPLATE_NAME = ENV.vorlage || new URLSearchParams(location.search).get('vorlage') || '4er-familienhaende';
let TEMPLATE = null;

let CALIBRATION = {};
/* Senkrechte Zielmitte der Gruppe. Standard ist die Seitenmitte; nur der Vergleichstest setzt den 30x40-Wert. */
let centerY = 0;

/* Lädt eine Datendatei. Im Shop liegen die Daten schon fertig vor (ENV.data), im Prototyp werden sie abgerufen. */
function loadJson(url) {
  if (ENV.data) {
    if (!ENV.data[url]) return Promise.reject(new Error(`${url}: nicht vorhanden`));
    return Promise.resolve(JSON.parse(JSON.stringify(ENV.data[url])));
  }
  return fetch(url, { cache: 'no-store' }).then((r) => { if (!r.ok) throw new Error(`${url}: ${r.status}`); return r.json(); });
}

async function loadTemplate(name) {
  // no-store: Vorlagen ändern sich beim Entwickeln oft, eine zwischengespeicherte alte Fassung führt in die Irre.
  const json = loadJson;
  const [shared, motif] = await Promise.all([json('vorlagen/gemeinsam.json'), json(`vorlagen/${name}.json`)]);
  // Im Shop kann das Theme einzelne Angaben überschreiben (Titel und Bild des Produkts bei der Standardvorlage).
  const t = { ...shared, ...motif, ...(ENV.overrides || {}) };
  // Jede Postergröße bekommt Rahmenbezeichnung, Rahmenpreis und Passepartout-Maße aus den gemeinsamen Daten.
  t.sizes = motif.sizes.map((x) => {
    if (!shared.frameSizes[x.id]) throw new Error(`Größe ${x.id} fehlt in gemeinsam.json`);
    return { ...x, ...shared.frameSizes[x.id] };
  });
  // Im Shop gelten die Preise des Produkts. Größen, die das Produkt nicht hat, entfallen.
  if (ENV.prices) t.sizes = t.sizes.filter((x) => ENV.prices[x.id] != null).map((x) => ({ ...x, price: ENV.prices[x.id] }));
  // Im Shop: Rahmenaufpreis aus den Varianten (Rahmenvariante minus Poster), damit er auch bei Aktionen zur Kasse passt.
  if (ENV.framePrices) t.sizes = t.sizes.map((x) => (ENV.framePrices[x.id] != null ? { ...x, framePrice: ENV.framePrices[x.id] } : x));
  // Regel, Drehung und Schriftgröße gelten für alle Namen der Vorlage, ein einzelnes Feld kann sie überschreiben.
  /*
   Feldarten (kind):
   - "name" (Standard): Name, der nach einer Platzierungsregel an die Zeichnung gesetzt wird
   - "zeile": waagerechte, mittig gesetzte Textzeile (Datum, eigener Spruch) mit eigener Schrift
   - "handname": Name, den Johannes für den Druck von Hand setzt. Die Vorschau zeigt ihn als Text (Annäherung)
  */
  const placement = t.placement || {};
  t.fields = motif.fields.map((f) => ({ kind: 'name', format: 'name', rule: placement.rule, angle: placement.angle, fontSize: t.fontSize, ...f }));
  t.fields.forEach((f) => { if (f.kind === 'name' && !PLACEMENT[f.rule]) throw new Error(`Unbekannte Platzierungsregel: ${f.rule}`); });
  // Ohne eigene Angabe stehen alle Felder in einem Abschnitt "Namen".
  t.sections = motif.sections || [{ title: 'Namen', fields: t.fields.map((f) => f.key) }];
  t.choices = motif.choices || [];
  // Querformat (Standardvorlage, das Theme setzt page quer): Passepartout-Maße mitdrehen. Die Set-Wand zeigt auch
  // Hochformate und rechnet deshalb mit den ungedrehten Maßen (passepartoutPreviewHoch).
  if (t.page[0] > t.page[1]) {
    const turn = (pp) => (pp ? { ...pp, sheet: [pp.sheet[1], pp.sheet[0]], side: pp.top, top: pp.side } : pp);
    t.sizes = t.sizes.map((x) => ({ ...x, passepartout: turn(x.passepartout) }));
    t.frameSizes = Object.fromEntries(Object.entries(t.frameSizes).map(([k, x]) => [k, { ...x, passepartout: turn(x.passepartout) }]));
    t.passepartoutPreviewHoch = t.passepartoutPreview;
    t.passepartoutPreview = turn(t.passepartoutPreview);
  }
  return t;
}

// Die Startgröße setzt die Vorlage (defaultSize).
const state = { size: null, frame: 'ohne', pp: false, hook: false, cards: [], values: {}, choices: {}, scrollToPp: false };
const $ = (id) => ROOT.getElementById(id);
const euro = (n) => n.toFixed(2).replace('.', ',') + ' €';
const SVG_NS = 'http://www.w3.org/2000/svg';

/* Pflichtschreibweise: jeder Namensteil beginnt groß, der Rest ist klein ("ANNA" und "anna" werden "Anna"). */
function capitalize(value) {
  return value.toLocaleLowerCase('de-DE').replace(/(^|[\s-])(\p{Ll})/gu, (m, sep, ch) => sep + ch.toLocaleUpperCase('de-DE'));
}

/*
 Zeichenprüfung. Angenommen werden lateinische, kyrillische und arabische Schrift: Namen aus Buchstaben, Leerzeichen,
 Bindestrich und Apostroph, freie Texte zusätzlich mit Ziffern und üblichen Satzzeichen. Alles andere (Chinesisch,
 Emojis ...) wird schon bei der Eingabe entfernt. Kyrillisch und Arabisch gibt es in den Schmuckschriften nicht,
 Johannes druckt solche Texte in einer anderen Schrift (gemeinsam.json: scriptFonts).
*/
const NOT_ALLOWED = {
  name: /[^\p{Script=Latin}\p{Script=Cyrillic}\p{Script=Arabic}\p{M} '’\-]/gu,
  zahl: /[^0-9]/g,
  frei: /[^\p{Script=Latin}\p{Script=Cyrillic}\p{Script=Arabic}\p{M}\p{N} .,:;!?&+'’‘°′″|"()\/\-–،؛؟]/gu,
};

/* Schrift, in der ein Text gesetzt wird: die eigentliche Schrift, bei kyrillischem oder arabischem Text die Ersatzschrift. */
function scriptOf(text) {
  if (/\p{Script=Cyrillic}/u.test(text)) return 'Cyrillic';
  if (/\p{Script=Arabic}/u.test(text)) return 'Arabic';
  return null;
}
const scriptFontsRequested = {};
/* Schriftname für SVG-Attribute in Anführungszeichen: ohne sie wäre z. B. "Schreibschrift 2" ungültig (letztes Wort eine Zahl)
   und der Browser nähme stillschweigend die Seitenschrift. */
function schriftAttr(name) { return name ? '"' + String(name).replace(/"/g, '') + '"' : name; }

function fontFor(text, font) {
  const script = scriptOf(text);
  const other = script && TEMPLATE.scriptFonts && TEMPLATE.scriptFonts[script];
  // Die Ersatzschrift wird erst geladen, wenn wirklich kyrillisch oder arabisch getippt wird. Sobald sie da ist,
  // wird neu gesetzt (die Messungen davor galten noch der Schrift des Geräts).
  if (other && !scriptFontsRequested[other]) {
    scriptFontsRequested[other] = true;
    document.fonts.load(`100px "${other}"`, text).then(() => { inkCache.clear(); glyphCache.clear(); (TEMPLATE.lines || []).forEach((L) => { L.fit = {}; }); if (fieldsBuilt) renderNames(); });
  }
  return other || font;
}

/* Prüft, ob die Schrift ein Zeichen wirklich enthält: Fehlt es, springt der Browser auf die Ersatzschrift, und die Breite hängt dann von ihr ab. */
const glyphCanvas = document.createElement('canvas').getContext('2d');
const glyphCache = new Map();
function hasGlyph(font, ch) {
  const key = `${font}|${ch}`;
  if (glyphCache.has(key)) return glyphCache.get(key);
  const width = (family) => { glyphCanvas.font = `100px ${family}`; return glyphCanvas.measureText(ch).width; };
  const stacks = ['monospace', 'serif', 'cursive'];
  const own = stacks.map((fallback) => width(`"${font}", ${fallback}`));
  const plain = stacks.map((fallback) => width(fallback));
  // Vorhanden, wenn die Breite nicht der Ersatzschrift folgt (alle drei gleich, oder anders als die Ersatzschriften).
  const ok = !own.every((w, i) => w === plain[i]) || plain.every((w) => w === plain[0]);
  glyphCache.set(key, ok);
  return ok;
}

/* Buchstaben ohne Zerlegung in Grundbuchstabe und Zusatz (türkisches ı, ø, ł ...). */
const BASE_LETTER = { 'ı': 'i', 'İ': 'I', 'ø': 'o', 'Ø': 'O', 'ł': 'l', 'Ł': 'L', 'đ': 'd', 'Đ': 'D', 'æ': 'ae', 'Æ': 'Ae', 'œ': 'oe', 'Œ': 'Oe', 'ß': 'ss' };

/*
 Text für die Vorschau: Zeichen, die es in der Schrift nicht gibt (z. B. türkisches ç, ş, ğ in der Schreibschrift),
 erscheinen als Grundbuchstabe. Johannes ergänzt den Zusatz für den Druck von Hand. Liefert auch, welche Zeichen das
 betrifft, damit das Feld darauf hinweisen kann. In den Warenkorb geht immer die echte Eingabe.
*/
function previewText(text, font) {
  // Text in Ersatzschrift (Kyrillisch, Arabisch) bleibt, wie er ist.
  if (scriptOf(text)) return { text, replaced: [], script: scriptOf(text) };
  const replaced = [];
  const out = [...text.normalize('NFC')].map((ch) => {
    if (ch === ' ' || hasGlyph(font, ch)) return ch;
    const base = BASE_LETTER[ch] || ch.normalize('NFD').replace(/\p{M}/gu, '');
    if (base && base !== ch && [...base].every((b) => hasGlyph(font, b))) { replaced.push(ch); return base; }
    return ch;
  }).join('');
  return { text: out, replaced };
}

/* Hinweis am Feld: entfernte Zeichen (nicht druckbar) gehen vor, sonst die von Hand ergänzten Sonderzeichen. */
function fieldInfo(f, replaced, script) {
  const info = f.el.querySelector('.info');
  if (f.removed) {
    info.textContent = 'Dieses Zeichen können wir leider nicht drucken. Möglich sind lateinische, kyrillische und arabische Schrift.';
  } else if (script) {
    info.textContent = `${script === 'Arabic' ? 'Arabische' : 'Kyrillische'} Schrift drucken wir in einer anderen, passenden Schriftart. Die Vorschau zeigt sie nur ungefähr.`;
  } else if (replaced && replaced.length) {
    const list = [...new Set(replaced)].map((ch) => `„${ch}“`).join(', ');
    info.textContent = `${list} setzt unser Grafikteam für den Druck von Hand ein. Die Vorschau zeigt den Buchstaben ohne Zusatz.`;
  } else {
    info.textContent = '';
  }
}

/* Ein Feld ist sichtbar, solange seine Bedingung (showIf: Auswahl hat einen bestimmten Wert) erfüllt ist. */
function isShown(f) {
  return !f.showIf || state.choices[f.showIf.choice] === f.showIf.is;
}

function typedValue(f) {
  return (state.values[f.key] || '').trim();
}

function buildField(f, container) {
  if (f.kind === 'foto') { buildPhotoField(f, container); return; }
  const label = document.createElement('label');
  label.className = 'field' + (f.labelHidden ? ' field--nolabel' : '');
  label.innerHTML = `<b>${f.label}<i>0/${f.max}</i></b>
    <input type="text" maxlength="${f.max}" placeholder="${f.placeholder}" autocomplete="off" aria-label="${f.label}">
    <span class="err">Dieses Feld ist erforderlich</span>
    <span class="info"></span>`;
  const input = label.querySelector('input');
  input.addEventListener('input', () => {
    // Nur Namen bekommen die Pflichtschreibweise, freie Texte (Datum, Spruch) bleiben wie eingegeben.
    const cleaned = input.value.replace(NOT_ALLOWED[f.format] || NOT_ALLOWED.frei, '');
    f.removed = cleaned !== input.value;
    // upper: Eingabe in Großbuchstaben (so stand sie bisher auch auf der Bestellung).
    const fixed = f.upper ? cleaned.toLocaleUpperCase('de-DE') : f.format === 'name' ? capitalize(cleaned) : cleaned;
    if (fixed !== input.value) {
      const pos = input.selectionStart;
      input.value = fixed;
      input.setSelectionRange(pos, pos);
    }
    state.values[f.key] = input.value;
    label.querySelector('i').textContent = `${input.value.length}/${f.max}`;
    label.classList.remove('invalid');
    // Ort für die Karte: kurz warten, bis die Eingabe steht, dann suchen.
    if (f.kind === 'ort') { clearTimeout(mapState.timer); mapState.timer = setTimeout(() => locate(f), 900); }
    TEMPLATE.fields.filter((x) => x.autoFrom === f.key).forEach((x) => { clearTimeout(x.autoTimer); x.autoTimer = setTimeout(() => autoCoordinates(x), x.autoKind === 'sternzeichen' ? 0 : 900); });
    renderNames();
  });
  if (f.kind === 'ort') input.addEventListener('change', () => { clearTimeout(mapState.timer); locate(f); });
  f.el = label;
  container.appendChild(label);

  const text = document.createElementNS(SVG_NS, 'text');
  text.setAttribute('font-family', schriftAttr(f.kind === 'handname' ? f.fallback.font : f.font || TEMPLATE.fontFamily));
  text.setAttribute('font-size', f.fontSize);
  text.setAttribute('fill', '#000');
  f.text = text;
  $('names').appendChild(text);
}

/* Baut die Abschnitte der Optionsspalte: Überschrift, optional eine Auswahl als Kacheln, Felder, optional ein Hinweis. */
function buildSections() {
  TEMPLATE.choices.forEach((c) => {
    state.choices[c.key] = c.default;
    // Zur Auswahl gehörende Bilder (z. B. ein fertig gesetzter Spruch) liegen über dem Motiv und werden nur umgeschaltet.
    c.options.filter((o) => o.overlay).forEach((o) => { o.image = addOverlay(o.overlay); });
    // Farbauswahl: Kachel mit Farbfläche.
    c.options.filter((o) => o.color).forEach((o) => { o.swatchHtml = `<span class="swatch swatch--color" style="background: ${o.color}"></span>`; });
    // Feste Textzeile einer Auswahl (z. B. "EIN LEBEN LANG"), gesetzt wie eine eingegebene Zeile.
    c.options.filter((o) => o.line).forEach((o) => {
      const text = document.createElementNS(SVG_NS, 'text');
      text.setAttribute('font-family', schriftAttr(o.line.font));
      text.setAttribute('fill', '#000');
      $('overlays').appendChild(text);
      o.lineField = { ...o.line, placeholder: o.line.text, required: true, text };
    });
  });
  TEMPLATE.sections.forEach((sec) => {
    const group = document.createElement('div');
    group.className = 'group';
    group.innerHTML = `<p class="group__title">${sec.title}</p>`;
    if (sec.choice) {
      const box = document.createElement('div');
      box.className = 'tiles tiles--choice' + (TEMPLATE.choices.find((c) => c.key === sec.choice).options.length > 5 ? ' tiles--many' : '');
      TEMPLATE.choices.find((c) => c.key === sec.choice).el = box;
      group.appendChild(box);
    }
    sec.fields.forEach((key) => buildField(TEMPLATE.fields.find((f) => f.key === key), group));
    if (sec.note) group.insertAdjacentHTML('beforeend', `<p class="note${sec.noteStrong ? ' note--strong' : ''}">${sec.note}</p>`);
    // noteMore [Frage, Antwort]: längere Erklärung zum Aufklappen, damit der Hinweis auf dem Handy kurz bleibt.
    if (sec.noteMore) group.insertAdjacentHTML('beforeend', `<details class="note-more"><summary>${sec.noteMore[0]}</summary><p>${sec.noteMore[1]}</p></details>`);
    $('sections').appendChild(group);
  });
  (TEMPLATE.lines || []).forEach((L) => {
    L.el = document.createElementNS(SVG_NS, 'text');
    $('names').appendChild(L.el);
  });
  if (TEMPLATE.calendar) {
    TEMPLATE.calendar.el = document.createElementNS(SVG_NS, 'g');
    $('names').appendChild(TEMPLATE.calendar.el);
  }
  fieldsBuilt = true;
}
let fieldsBuilt = false;

function addOverlay(o) {
  const img = document.createElementNS(SVG_NS, 'image');
  img.setAttribute('href', asset(o.href));
  img.setAttribute('x', 0);
  img.setAttribute('y', o.y);
  img.setAttribute('width', TEMPLATE.page[0]);
  img.setAttribute('height', o.height);
  // multiply: das weiße Papier des Bildes verschwindet, darunterliegende Linien bleiben stehen.
  img.style.mixBlendMode = 'multiply';
  if (o.opacity) img.style.opacity = o.opacity;
  // Fehlt die Datei (z. B. ein nur lokal vorhandenes Beispielbild), bleibt die Stelle einfach leer.
  img.addEventListener('error', () => img.remove());
  $('overlays').appendChild(img);
  return img;
}

/*
 Zeigt einen Namen der Hochzeitshände. Johannes setzt diese Namen für den Druck von Hand; seine Namensbibliothek
 liegt bewusst NICHT im Shop (sie wäre dort für jeden abrufbar). Die Vorschau setzt den Namen deshalb als Text:
 - Größe wie in der 1-Click-App für unbekannte Namen (PhraseKerningLibrary.nameSizePixels): jeder Name wird auf
   ungefähr dieselbe Breite gebracht, mit Unter- und Obergrenze.
 - Winkel und Andockpunkt sind Mittelwerte aus den von Hand gesetzten Namen (links dockt das Wortende an, rechts
   beginnt der Name fest an der Linie).
 Leeres Feld: Beispielname blass.
*/
function renderHandName(f) {
  const typed = typedValue(f);
  const raw = typed || f.placeholder;
  const txt = f.text;
  const fb = f.fallback;
  const font = fontFor(raw, fb.font);
  const shown = previewText(raw, font);
  fieldInfo(f, typed ? shown.replaced : [], typed ? shown.script : null);
  txt.setAttribute('font-family', schriftAttr(font));
  txt.setAttribute('opacity', typed ? '1' : '0.35');
  // Sichtbare Breite bei Schriftgröße 1000, gemessen bei 200 und hochgerechnet (spart Rechenzeit).
  const flat = inkBoundsRotated(shown.text, 200, 0, font);
  const width1000 = (flat.maxX - flat.minX) * 5;
  let size = Math.max(fb.minSize, Math.min(fb.maxSize, 1000 * fb.targetWidth / width1000));
  const rad = fb.angle * Math.PI / 180;
  /*
   Regel von Johannes: Der Name liegt zwischen dem Andockpunkt unten (dort beginnen die unteren Striche der Hände)
   und dem oberen Ende der Striche (topLimit). Ragt er darüber hinaus, wird er verkleinert, bis er hineinpasst.
   Gemessen an der Tinte des gedrehten Namens, vom Andockpunkt aus.
  */
  // Der Andockpunkt der Grundlinie hängt von der Schriftgröße ab: Die Linie der Hände trifft den Buchstaben auf
  // halber Höhe, bei kleinerer Schrift rückt die Grundlinie deshalb näher an die Linie.
  const anchorFor = (px) => [fb.anchorBase[0] + fb.anchorPerSize[0] * px, fb.anchorBase[1] + fb.anchorPerSize[1] * px];
  const reach = (px) => {
    const ink = inkBoundsRotated(shown.text, 200, fb.angle, font);
    const k = px / 200;
    const ay = anchorFor(px)[1];
    const originY = fb.dock === 'ende' ? ay + ink.advance * k * Math.sin(rad) : ay;
    return { reach: ay - (originY + ink.minY * k), room: ay - fb.topLimit };
  };
  // Zweimal nachziehen, weil sich mit der Größe auch der Andockpunkt leicht verschiebt.
  for (let i = 0; i < 2; i++) {
    const r = reach(size);
    if (r.reach > r.room) size *= r.room / r.reach;
  }
  const advance = flat.advance * size / 200;
  const [ax, ay] = anchorFor(size);
  const tx = fb.dock === 'ende' ? ax - advance * Math.cos(rad) : ax;
  const ty = fb.dock === 'ende' ? ay + advance * Math.sin(rad) : ay;
  txt.textContent = shown.text;
  txt.setAttribute('font-size', size);
  txt.setAttribute('transform', `translate(${tx} ${ty}) rotate(${-fb.angle})`);
}

/* Lauflänge einer waagerechten Zeile in Seitenpixeln, ohne den Abstand hinter dem letzten Zeichen. */
function lineWidth(text, font, fontSize, tracking, weight = 400) {
  const ctx = inkCanvas.getContext('2d');
  ctx.font = `${weight} ${fontSize}px "${font}"`;
  ctx.letterSpacing = `${tracking * fontSize}px`;
  const w = ctx.measureText(text).width - tracking * fontSize;
  ctx.letterSpacing = '0px';
  return w;
}

/*
 Setzt eine mittige Textzeile. Größenregel wie in der 1-Click-App beim eigenen Spruch: kurze Texte wachsen bis zur
 Wunschbreite (growToWidth), höchstens um growMaxScale, lange werden auf maxWidth verkleinert.
*/
function renderLine(f) {
  const typed = typedValue(f);
  // auto: Die Zeile bekommt ihren Wert von der Karte (Ort und Koordinaten), solange nichts Eigenes eingetragen ist.
  const auto = !typed && f.auto ? (f.autoValue || '') : '';
  const real = Boolean(typed || (auto && !f.autoExample));
  let value = typed || auto || f.placeholder;
  if (f.uppercase) value = value.toLocaleUpperCase('de-DE');
  const font = fontFor(value, f.font);
  if (f.el) {
    const shown = previewText(value, font);
    value = shown.text;
    fieldInfo(f, typed ? shown.replaced : [], typed ? shown.script : null);
  }
  f.text.setAttribute('font-family', schriftAttr(font));
  const tracking = f.tracking || 0;
  const base = lineWidth(value, font, f.fontSize, tracking);
  let scale = 1;
  if (f.growToWidth) scale = Math.min(f.growMaxScale || 1, f.growToWidth / base);
  if (f.maxWidth && base * scale > f.maxWidth) scale = f.maxWidth / base;
  const size = f.fontSize * scale;
  const t = f.text;
  t.textContent = value;
  t.setAttribute('font-size', size);
  t.setAttribute('letter-spacing', tracking * size);
  t.setAttribute('text-anchor', 'middle');
  // Der Abstand hinter dem letzten Zeichen zählt bei der Zentrierung mit, deshalb um die Hälfte zurückschieben.
  t.setAttribute('x', TEMPLATE.page[0] / 2 + tracking * size / 2);
  t.setAttribute('y', f.baseline);
  t.setAttribute('opacity', real ? '1' : '0.35');
  // Eine freiwillige Zeile erscheint erst, wenn etwas eingegeben ist. Sonst sähe ihr Beispieltext wie bestellt aus.
  t.style.display = isShown(f) && (typed || auto || f.required) ? '' : 'none';
}

/*
 Misst die Tinte eines Namens (ungedreht, relativ zum Textursprung auf der Grundlinie), so wie Photoshop
 die Ebenengrenzen misst. Gemessen wird in halber Größe und hochgerechnet, das reicht auf einen Pixel genau.
*/
const inkCanvas = document.createElement('canvas');
const inkCache = new Map();
function inkBounds(text, fontSize, font = TEMPLATE.fontFamily, weight = 400) {
  const cacheKey = `${font}|${weight}|${fontSize}|${text}`;
  if (inkCache.has(cacheKey)) return inkCache.get(cacheKey);
  const scale = 0.5;
  const size = fontSize * scale;
  const ctx = inkCanvas.getContext('2d', { willReadFrequently: true });
  ctx.font = `${weight} ${size}px "${font}"`;
  const pad = Math.ceil(size * 1.5);
  const w = Math.ceil(ctx.measureText(text).width) + pad * 2;
  const h = Math.ceil(size * 4);
  inkCanvas.width = w; inkCanvas.height = h;
  ctx.font = `${weight} ${size}px "${font}"`;
  ctx.textBaseline = 'alphabetic';
  ctx.fillStyle = '#000';
  const ox = pad, oy = Math.round(size * 2.4);
  ctx.fillText(text, ox, oy);
  const data = ctx.getImageData(0, 0, w, h).data;
  let minX = w, maxX = -1, minY = h, maxY = -1;
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      if (data[(y * w + x) * 4 + 3] > 24) {
        if (x < minX) minX = x; if (x > maxX) maxX = x;
        if (y < minY) minY = y; if (y > maxY) maxY = y;
      }
    }
  }
  const b = maxX < 0
    ? { minX: 0, maxX: 0, minY: 0, maxY: 0 }
    : { minX: (minX - ox) / scale, maxX: (maxX + 1 - ox) / scale, minY: (minY - oy) / scale, maxY: (maxY + 1 - oy) / scale };
  inkCache.set(cacheKey, b);
  return b;
}

/*
 Wie inkBounds, aber für einen um angle Grad (gegen den Uhrzeigersinn) gedrehten Namen: Rahmen der Tinte auf der
 Seite relativ zum Textursprung, dazu die Lauflänge des Wortes (advance) entlang der Grundlinie.
*/
function inkBoundsRotated(text, fontSize, angle, font = TEMPLATE.fontFamily) {
  const cacheKey = `${font}|${fontSize}|${angle}|${text}`;
  if (inkCache.has(cacheKey)) return inkCache.get(cacheKey);
  const scale = 0.5;
  const size = fontSize * scale;
  const ctx = inkCanvas.getContext('2d', { willReadFrequently: true });
  ctx.font = `${size}px "${font}"`;
  const advance = ctx.measureText(text).width;
  const side = Math.ceil((advance + size * 4) * 2);
  inkCanvas.width = side; inkCanvas.height = side;
  const o = side / 2;
  ctx.translate(o, o);
  ctx.rotate(-angle * Math.PI / 180);
  ctx.font = `${size}px "${font}"`;
  ctx.textBaseline = 'alphabetic';
  ctx.fillStyle = '#000';
  ctx.fillText(text, 0, 0);
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  const data = ctx.getImageData(0, 0, side, side).data;
  let minX = side, maxX = -1, minY = side, maxY = -1;
  for (let y = 0; y < side; y++) {
    for (let x = 0; x < side; x++) {
      if (data[(y * side + x) * 4 + 3] > 24) {
        if (x < minX) minX = x; if (x > maxX) maxX = x;
        if (y < minY) minY = y; if (y > maxY) maxY = y;
      }
    }
  }
  const b = maxX < 0
    ? { minX: 0, maxX: 0, minY: 0, maxY: 0, advance: 0 }
    : { minX: (minX - o) / scale, maxX: (maxX + 1 - o) / scale, minY: (minY - o) / scale, maxY: (maxY + 1 - o) / scale, advance: advance / scale };
  inkCache.set(cacheKey, b);
  return b;
}

/* Tabellenwert für Position und Anfangsbuchstaben. Umlaute und Akzente fallen auf den Grundbuchstaben zurück. */
function target(position, name) {
  const first = name.trim().charAt(0).normalize('NFD').charAt(0).toUpperCase();
  return CALIBRATION[`${position}${first}`] || CALIBRATION[`${position}${TEMPLATE.placement.fallbackLetter}`];
}

/*
 Platzierungsregeln je Vorlage (placement.rule). Jede Regel liefert für einen Namen die Verschiebung (tx, ty) des
 Textursprungs und den Rahmen der Tinte auf der Seite [links, oben, rechts, unten].
 "tinte-links-unten" ist die Regel des 4er Familienbilds: Text um -90 Grad gedreht, die linke und die untere Kante
 der Tinte liegen auf dem Tabellenwert für (Position, Anfangsbuchstabe).
*/
const PLACEMENT = {
  'tinte-links-unten': (field, value) => {
    const ink = inkBounds(value, field.fontSize, field.activeFont);
    const pos = target(field.position, value);
    // Um -90 Grad gedreht: Seite x = tx + lokal y, Seite y = ty - lokal x
    const tx = pos.x - ink.minY;
    const ty = pos.y + ink.minX;
    return { tx, ty, box: [pos.x, ty - ink.maxX, tx + ink.maxY, pos.y] };
  },
  // 2er, 3er, 5er (1-Click: useTextAnchor): Textursprung auf Tabellenwert plus festem Versatz der Namensebene.
  textanker: (field, value) => {
    const pos = target(field.position, value);
    return atOrigin(field, value, pos.x + field.originOffset[0], pos.y + field.originOffset[1]);
  },
  // Das Wortende liegt auf field.anchor (letzter Buchstabe dockt an der Linie an).
  wortende: (field, value) => {
    const { advance } = inkBoundsRotated(value, field.fontSize, field.angle, field.activeFont);
    const rad = field.angle * Math.PI / 180;
    return atOrigin(field, value, field.anchor[0] - advance * Math.cos(rad), field.anchor[1] + advance * Math.sin(rad));
  },
  // Die Mitte der Grundlinie liegt auf field.anchor (Annäherung für rein optisch gesetzte Namen).
  wortmitte: (field, value) => {
    const { advance } = inkBoundsRotated(value, field.fontSize, field.angle, field.activeFont);
    const rad = field.angle * Math.PI / 180;
    return atOrigin(field, value, field.anchor[0] - advance / 2 * Math.cos(rad), field.anchor[1] + advance / 2 * Math.sin(rad));
  },
};

function atOrigin(field, value, tx, ty) {
  const ink = inkBoundsRotated(value, field.fontSize, field.angle, field.activeFont);
  return { tx, ty, box: [tx + ink.minX, ty + ink.minY, tx + ink.maxX, ty + ink.maxY] };
}

/*
 Karte (Vorlagen mit "map", z. B. "Wo alles begann"). Der Kunde gibt eine Adresse oder Koordinaten ein, die Vorschau
 zeigt den Kartenausschnitt in den Händen, das Herz sitzt auf dem Ort. Für den Druck holt die 1-Click-App die Karte
 selbst (Google, Zoom 15); die Vorschau zeichnet denselben Ausschnitt aus freien OpenStreetMap-Daten im selben Stil.
 Auf die Bestellzeile kommen die gefundenen Koordinaten, damit gedruckt wird, was die Vorschau gezeigt hat.
*/
const mapState = { lat: null, lon: null, city: '', found: false, query: '', token: 0, timer: null, map: null, loading: null };

/* Liest Koordinaten aus freiem Text, in denselben Schreibweisen wie die 1-Click-App (CoordinateMapFetcher.parseCoordinates). */
function parseCoordinates(text) {
  const num = (v) => Number(String(v).replace(',', '.'));
  const ok = (lat, lon) => (Number.isFinite(lat) && Number.isFinite(lon) && Math.abs(lat) <= 90 && Math.abs(lon) <= 180 ? { lat, lon } : null);
  const sign = (v, hemi) => (/[sw]/i.test(hemi) ? -v : v);
  let m = text.match(/(-?\d{1,3}\.\d+)\s*°?\s*,\s*(-?\d{1,3}\.\d+)\s*°?/);
  if (m) return ok(num(m[1]), num(m[2]));
  m = text.match(/(\d{1,3})°\s*(\d{1,2})['′]\s*(\d{1,2}(?:[.,]\d+)?)["″]\s*([NSns])[^\d]+(\d{1,3})°\s*(\d{1,2})['′]\s*(\d{1,2}(?:[.,]\d+)?)["″]\s*([OWEowe])/);
  if (m) return ok(sign(num(m[1]) + num(m[2]) / 60 + num(m[3]) / 3600, m[4]), sign(num(m[5]) + num(m[6]) / 60 + num(m[7]) / 3600, m[8]));
  m = text.match(/(\d{1,3})°\s*(\d{1,2}(?:[.,]\d+)?)['′]\s*([NSns])[^\d]+(\d{1,3})°\s*(\d{1,2}(?:[.,]\d+)?)['′]\s*([OWEowe])/);
  if (m) return ok(sign(num(m[1]) + num(m[2]) / 60, m[3]), sign(num(m[4]) + num(m[5]) / 60, m[6]));
  m = text.match(/(\d{1,3}(?:[.,]\d+)?)\s*°\s*([NSns])[^\d]+(\d{1,3}(?:[.,]\d+)?)\s*°\s*([OWEowe])/);
  if (m) return ok(sign(num(m[1]), m[2]), sign(num(m[3]), m[4]));
  m = text.match(/(-?\d{1,3}),(\d+)\s*,\s*(-?\d{1,3}),(\d+)/);
  if (m) return ok(Number(`${m[1]}.${m[2]}`), Number(`${m[3]}.${m[4]}`));
  return null;
}

function geocoderUrl() { return (TEMPLATE.map && TEMPLATE.map.geocoder) || TEMPLATE.geocoder; }

/*
 Feld mit "autoFrom": Sein Wert entsteht aus einem anderen Feld, hier die Koordinaten zur eingegebenen Stadt
 (bisher von Johannes von Hand nachgeschlagen). Der Kunde kann den Wert überschreiben.
*/
const ZODIAC = [[1, 20, 'Steinbock'], [2, 19, 'Wassermann'], [3, 20, 'Fische'], [4, 20, 'Widder'], [5, 20, 'Stier'], [6, 21, 'Zwillinge'], [7, 22, 'Krebs'], [8, 23, 'Löwe'], [9, 23, 'Jungfrau'], [10, 23, 'Waage'], [11, 22, 'Skorpion'], [12, 21, 'Schütze'], [12, 31, 'Steinbock']];
function autoCoordinates(target) {
  const source = TEMPLATE.fields.find((f) => f.key === target.autoFrom);
  const query = typedValue(source);
  if (query === target.autoQuery) return;
  target.autoQuery = query;
  // autoKind "sternzeichen": aus Tag und Monat des Geburtsdatums, ohne Abfrage nach außen.
  if (target.autoKind === 'sternzeichen') {
    const m = query.match(/(\d{1,2})\D+(\d{1,2})/);
    const day = m && Number(m[1]), month = m && Number(m[2]);
    const hit = m && month >= 1 && month <= 12 && day >= 1 && day <= 31 && ZODIAC.find(([mo, last]) => month < mo || (month === mo && day <= last));
    target.autoValue = hit ? hit[2] : '';
    target.el.querySelector('input').placeholder = target.autoValue || target.placeholder;
    renderNames();
    return;
  }
  if (query.length < 3) { target.autoValue = ''; renderNames(); return; }
  geocode(query).then((hit) => {
    if (target.autoQuery !== query) return;
    const n = (v) => Math.abs(v).toFixed(6);
    // autoKind "dms": Grad, Minuten, Sekunden wie auf dem Anker-Poster (48°8‘51‘‘N 11°34‘27‘‘O), sonst Dezimalgrad.
    const dms = (v) => { const t = Math.round(Math.abs(v) * 3600); return `${Math.floor(t / 3600)}°${Math.floor(t % 3600 / 60)}‘${t % 60}‘‘`; };
    target.autoValue = !hit ? '' : target.autoKind === 'dms'
      ? `${dms(hit.lat)}${hit.lat >= 0 ? 'N' : 'S'} ${dms(hit.lon)}${hit.lon >= 0 ? 'O' : 'W'}`
      : `${n(hit.lat)}°${hit.lat >= 0 ? 'N' : 'S'}, ${n(hit.lon)}°${hit.lon >= 0 ? 'O' : 'W'}`;
    target.el.querySelector('input').placeholder = target.autoValue || target.placeholder;
    target.el.querySelector('.info').textContent = hit ? '' : 'Dazu finden wir keine Koordinaten. Du kannst sie hier selbst eintragen.';
    renderNames();
  }).catch((error) => console.error(error));
}

/* Adresse in Koordinaten umwandeln bzw. zu Koordinaten den Ort nachschlagen (freier Dienst Photon, OpenStreetMap-Daten). */
async function geocode(query) {
  const r = await fetch(`${geocoderUrl()}/api/?q=${encodeURIComponent(query)}&limit=1&lang=de`);
  if (!r.ok) throw new Error(`Ortssuche: ${r.status}`);
  const hit = (await r.json()).features[0];
  if (!hit) return null;
  const p = hit.properties;
  const street = [p.street || (p.osm_key === 'highway' ? p.name : ''), p.housenumber].filter(Boolean).join(' ');
  const city = p.city || p.town || p.village || p.name || '';
  return { lat: hit.geometry.coordinates[1], lon: hit.geometry.coordinates[0], city, label: [street || (p.name !== city ? p.name : ''), [p.postcode, city].filter(Boolean).join(' ')].filter(Boolean).join(', ') };
}
async function reverseCity(lat, lon) {
  const r = await fetch(`${geocoderUrl()}/reverse?lat=${lat}&lon=${lon}&lang=de`);
  if (!r.ok) return '';
  const hit = (await r.json()).features[0];
  return hit ? (hit.properties.city || hit.properties.town || hit.properties.village || hit.properties.name || '') : '';
}

/* Textzeile unter den Namen, so wie Johannes sie bisher von Hand einträgt: "Berlin  52,516308N | 13,37765E". */
function mapLine(lat, lon, city) {
  const n = (v) => Math.abs(v).toFixed(6).replace(/0+$/, '').replace(/\.$/, '').replace('.', ',');
  return `${city ? `${city}  ` : ''}${n(lat)}${lat >= 0 ? 'N' : 'S'} | ${n(lon)}${lon >= 0 ? 'E' : 'W'}`;
}

/* Kartenstil wie die Google-Karte der 1-Click-App: weißer Grund, schwarze Straßen, graues Wasser, keine Beschriftung. */
function mapStyle() {
  const road = (id, classes, width, extra = {}) => ({
    id, type: 'line', source: 'osm', 'source-layer': 'transportation', filter: ['in', 'class', ...classes],
    layout: { 'line-cap': 'round', 'line-join': 'round' }, paint: { 'line-color': '#0a0a0a', 'line-width': width, ...extra },
  });
  return {
    version: 8,
    sources: { osm: { type: 'vector', url: TEMPLATE.map.tiles } },
    layers: [
      { id: 'grund', type: 'background', paint: { 'background-color': '#ffffff' } },
      { id: 'wasser', type: 'fill', source: 'osm', 'source-layer': 'water', paint: { 'fill-color': '#8f8f8f' } },
      { id: 'bach', type: 'line', source: 'osm', 'source-layer': 'waterway', paint: { 'line-color': '#8f8f8f', 'line-width': 1.5 } },
      // Linienstärken am Beispielbild des Shops abgelesen (Google-Karte der 1-Click-App): Hauptstraßen kräftig,
      // Nebenstraßen dünn, Zufahrten und Wege haarfein, Fußwege gestrichelt. Gebäude zeigt die Druckkarte nicht.
      road('weg', ['path'], 0.45, { 'line-dasharray': [5, 4] }),
      road('zufahrt', ['service'], 0.5),
      road('klein', ['minor'], 1.4),
      road('mittel', ['tertiary'], 3),
      road('gross', ['secondary', 'primary', 'trunk', 'motorway'], 3.6),
    ],
  };
}

/* Zeichnet die Karte um den Ort und liefert sie als Bild. Die Kartenbibliothek wird erst beim ersten Bedarf geladen. */
function drawMap(lat, lon, wanted) {
  // Immer nur eine Karte zur Zeit zeichnen (Beispielkarte und erste Eingabe können sich sonst überholen).
  // Ist die Anfrage beim Drankommen schon überholt (wanted), wird sie übersprungen.
  const next = (mapState.queue || Promise.resolve()).catch(() => {}).then(() => (wanted() ? drawMapNow(lat, lon) : null));
  mapState.queue = next;
  return next;
}
async function drawMapNow(lat, lon) {
  const m = TEMPLATE.map;
  if (!window.maplibregl) {
    mapState.loading = mapState.loading || new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = asset(m.library);
      script.onload = resolve;
      script.onerror = () => reject(new Error('Kartenbibliothek nicht geladen'));
      document.head.appendChild(script);
    });
    await mapState.loading;
  }
  if (!mapState.map) {
    // Unsichtbare Zeichenfläche außerhalb des Bildes, in Kartenpixeln so groß wie der Ausschnitt der 1-Click-App.
    const box = document.createElement('div');
    const w = Math.round((m.area[2] - m.area[0]) / m.pagePxPerMapPx), h = Math.round((m.area[3] - m.area[1]) / m.pagePxPerMapPx);
    // display ausdrücklich gesetzt: das Shop-Theme blendet leere <div> aus, die Karte bekäme sonst die Größe 0.
    box.style.cssText = `display: block !important; position: fixed; left: -20000px; top: 0; width: ${w}px; height: ${h}px; pointer-events: none;`;
    document.body.appendChild(box);
    // Zoom: Google rechnet mit 256er Kacheln, diese Bibliothek mit 512ern, deshalb eine Stufe weniger.
    mapState.map = new window.maplibregl.Map({ container: box, style: mapStyle(), center: [lon, lat], zoom: m.zoom - 1, interactive: false, attributionControl: false, preserveDrawingBuffer: true, pixelRatio: 2, fadeDuration: 0 });
  } else {
    mapState.map.jumpTo({ center: [lon, lat] });
  }
  await Promise.race([
    new Promise((resolve) => mapState.map.once('idle', resolve)),
    new Promise((resolve, reject) => setTimeout(() => reject(new Error('Karte: Zeitüberschreitung')), 15000)),
  ]);
  return mapState.map.getCanvas().toDataURL('image/jpeg', 0.9);
}

/* Zeigt die Karte um einen Ort in den Händen. example: blasse Beispielkarte, solange noch nichts eingegeben ist. */
async function showMap(lat, lon, city, example, token) {
  const href = await drawMap(lat, lon, () => token === mapState.token);
  if (!href || token !== mapState.token) return false;
  return showMapImage(href, lat, lon, city, example);
}
/* Setzt ein fertiges Kartenbild in die Hände (gezeichnete Karte oder festes Beispielbild). */
function showMapImage(href, lat, lon, city, example) {
  const image = $('map-image');
  image.setAttribute('href', href);
  image.setAttribute('opacity', example ? '0.4' : '1');
  const line = TEMPLATE.fields.find((f) => f.key === TEMPLATE.map.lineField);
  if (line) {
    line.autoValue = mapLine(lat, lon, city).slice(0, line.max);
    line.autoExample = example;
    if (!example) {
      const input = line.el.querySelector('input');
      input.placeholder = line.autoValue;
      // Vorausgefüllt und änderbar (Johannes 20.10.2026, Variante C): steht nichts Eigenes im Feld, kommt der Ort mit
      // Koordinaten aus der Adresssuche hinein. Hat der Kunde den Text geändert, bleibt seiner stehen.
      if (!input.value || input.value === line.lastAuto) {
        input.value = line.autoValue;
        line.lastAuto = line.autoValue;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  }
  renderNames();
  render();
  return true;
}

/* Sucht den eingegebenen Ort und zeigt die Karte. Meldungen stehen unter dem Feld. */
async function locate(f) {
  const text = typedValue(f);
  if (text === mapState.query && (mapState.found || !text)) return;
  const token = ++mapState.token;
  const info = f.el.querySelector('.info');
  Object.assign(mapState, { query: text, found: false });
  f.el.classList.remove('field--ok');
  if (text.length < 4) { info.textContent = ''; return; }
  info.textContent = 'Karte wird geladen …';
  try {
    let hit = parseCoordinates(text);
    if (hit) {
      hit.city = await reverseCity(hit.lat, hit.lon).catch(() => '');
      hit.label = `${hit.lat.toFixed(6)}, ${hit.lon.toFixed(6)}${hit.city ? ` (${hit.city})` : ''}`;
    } else {
      hit = await geocode(text);
    }
    if (token !== mapState.token) return;
    if (!hit) { info.textContent = 'Diesen Ort finden wir nicht. Bitte gib Straße, Hausnummer, Postleitzahl und Ort an oder trage Koordinaten ein.'; return; }
    if (!(await showMap(hit.lat, hit.lon, hit.city, false, token))) return;
    Object.assign(mapState, { lat: hit.lat, lon: hit.lon, city: hit.city, found: true });
    // Deutliche Bestätigung: die Karte in der Vorschau zeigt jetzt diesen Ort.
    // Haken im Feld hinter der Eingabe, darunter nur "Karte aktualisiert" in Grün.
    info.innerHTML = '<span class="found">Karte aktualisiert</span>';
    f.el.classList.add('field--ok');
    f.el.classList.remove('invalid');
  } catch (error) {
    if (token !== mapState.token) return;
    info.textContent = 'Die Karte konnte gerade nicht geladen werden. Bitte versuche es gleich noch einmal.';
    console.error(error);
  }
}

/*
 Foto (Vorlagen mit "photo", die Definition-Poster). Der Kunde wählt ein Bild von seinem Gerät. Es füllt die
 Fotofläche des Motivs; den Ausschnitt verschiebt er mit Finger oder Maus direkt in der Vorschau, die Größe mit dem
 Regler. In den Warenkorb gehen zwei Dateien: der Ausschnitt so, wie er zu sehen war, und das Original.
*/
const photo = { file: null, img: null, zoom: 1, cx: 0.5, cy: 0.5 };

function buildPhotoField(f, container) {
  const label = document.createElement('div');
  label.className = 'field';
  label.innerHTML = `<div class="foto">
      <input type="file" accept="image/jpeg,image/png" hidden>
      <button type="button" class="foto__pick">Foto auswählen</button>
      <span class="foto__name">JPG oder PNG</span>
      <span class="foto__zoom" hidden>Größe <input type="range" min="1" max="3" step="0.01" value="1" aria-label="Größe des Ausschnitts"></span>
    </div>
    <span class="err">Bitte wähle ein Foto aus.</span>
    <span class="info"></span>
    <span class="foto__tipp">Für einen optimalen Druck sollte dein Foto eine möglichst hohe Auflösung haben.</span>`;
  const input = label.querySelector('input[type=file]');
  label.querySelector('.foto__pick').addEventListener('click', () => input.click());
  input.addEventListener('change', () => {
    const file = input.files[0];
    if (!file) return;
    const info = label.querySelector('.info');
    if (!/^image\/(jpeg|png)$/.test(file.type)) { info.textContent = 'Bitte ein Foto als JPG oder PNG wählen.'; return; }
    if (file.size > 20 * 1024 * 1024) { info.textContent = 'Das Foto ist zu groß (höchstens 20 MB).'; return; }
    const img = new Image();
    img.onload = () => {
      Object.assign(photo, { file, img, zoom: 1, cx: 0.5, cy: 0.5 });
      state.values[f.key] = file.name;
      label.classList.remove('invalid');
      label.querySelector('.foto__name').textContent = file.name;
      label.querySelector('.foto__pick').textContent = 'Anderes Foto';
      label.querySelector('.foto__zoom').hidden = false;
      label.querySelector('.foto__zoom input').value = 1;
      renderPhoto();
      render();
    };
    img.onerror = () => { info.textContent = 'Dieses Bild können wir leider nicht lesen.'; };
    img.src = URL.createObjectURL(file);
  });
  label.querySelector('.foto__zoom input').addEventListener('input', (e) => { photo.zoom = Number(e.target.value); renderPhoto(); });
  f.el = label;
  container.appendChild(label);
}

/* Lage des Fotos in der Fotofläche: füllt sie immer ganz aus, der gewählte Bildpunkt (cx, cy) sitzt in der Mitte. */
function photoPlacement() {
  const [x0, y0, x1, y1] = TEMPLATE.photo.box;
  const bw = x1 - x0, bh = y1 - y0, iw = photo.img.naturalWidth, ih = photo.img.naturalHeight;
  const scale = Math.max(bw / iw, bh / ih) * photo.zoom;
  const w = iw * scale, h = ih * scale;
  // Mittelpunkt so begrenzen, dass nirgends eine Lücke entsteht.
  photo.cx = Math.max(bw / 2 / w, Math.min(1 - bw / 2 / w, photo.cx));
  photo.cy = Math.max(bh / 2 / h, Math.min(1 - bh / 2 / h, photo.cy));
  return { x: x0 + bw / 2 - photo.cx * w, y: y0 + bh / 2 - photo.cy * h, w, h, scale, bw, bh };
}

function renderPhoto() {
  if (!photo.img) return;
  const p = photoPlacement();
  const image = $('foto-image');
  image.setAttribute('href', photo.img.src);
  image.setAttribute('x', p.x); image.setAttribute('y', p.y);
  image.setAttribute('width', p.w); image.setAttribute('height', p.h);
  $('foto-hint').style.display = 'none';
  // Keine Auflösungsprüfung mehr (Wunsch von Johannes): der Hinweis unter dem Feld reicht. Hier nur die Bedienung.
  const field = TEMPLATE.fields.find((x) => x.kind === 'foto');
  field.el.querySelector('.info').textContent = 'Verschiebe das Foto in der Vorschau und vergrößere es mit dem Regler, bis der Ausschnitt passt.';
}

/* Der Ausschnitt als eigene Bilddatei, so wie er in der Vorschau zu sehen ist (höchstens 3000 px breit). */
function photoCrop() {
  const p = photoPlacement();
  const sw = p.bw / p.scale, sh = p.bh / p.scale;
  const sx = photo.cx * photo.img.naturalWidth - sw / 2, sy = photo.cy * photo.img.naturalHeight - sh / 2;
  const k = Math.min(1, 3000 / sw);
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(sw * k); canvas.height = Math.round(sh * k);
  canvas.getContext('2d').drawImage(photo.img, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height);
  return new Promise((resolve) => canvas.toBlob((blob) => resolve(new File([blob], 'foto-ausschnitt.jpg', { type: 'image/jpeg' })), 'image/jpeg', 0.92));
}

/*
 Zusammengesetzte Textzeilen (Vorlagen mit "lines", die reinen Text-Motive). Eine Zeile besteht aus festem Text und
 Platzhaltern {Feldname}, z. B. "{Name Links} & {Name Rechts}". Die Felder dazu sind schlichte Eingaben (kind "wert").
 Jede Zeile bringt aus der Photoshop-Vorlage ihren Beispieltext samt Tintenrahmen mit (calib): daran richtet die Maske
 Schriftgröße (über die Höhe) und Zeichenabstand (über die Breite) aus. So stimmt die Zeile auch dann, wenn statt der
 Originalschrift eine freie Ersatzschrift oder die Schrift des Geräts verwendet wird.
*/
function calibrate(L, font) {
  const key = `${font}|${L.weight || 400}`;
  L.fit = L.fit || {};
  if (L.fit[key]) return L.fit[key];
  let size = L.fontSize, tracking = L.tracking || 0;
  if (L.calib) {
    const sample = L.uppercase ? L.calib.text.toLocaleUpperCase('de-DE') : L.calib.text;
    const ink = inkBounds(sample, L.fontSize, font, L.weight || 400);
    const height = ink.maxY - ink.minY, width = ink.maxX - ink.minX;
    if (height > 0 && width > 0) {
      const k = Math.max(0.6, Math.min(1.6, (L.calib.height / (L.stretchY || 1)) / height));
      size = L.fontSize * k;
      const gaps = [...sample].length - 1;
      if (gaps > 0 && L.calib.width) tracking = Math.max(-0.08, Math.min(0.8, (L.calib.width - width * k) / (size * gaps)));
    }
  }
  return (L.fit[key] = { size, tracking });
}

/*
 Kalenderblatt (Vorlagen mit "calendar", Wedding Calendar): die Tage des gewählten Monats fortlaufend in sieben
 Spalten, wie in der Photoshop-Vorlage (ohne Wochentage). Auf dem eingegebenen Tag liegt das Herz, die Zahl darin
 ist weiß. Anzahl der Tage aus Monat und Jahr (Schaltjahr).
*/
function renderCalendar() {
  const C = TEMPLATE.calendar;
  const box = C.el;
  const field = (key) => TEMPLATE.fields.find((f) => f.key === key);
  const choice = TEMPLATE.choices.find((c) => c.key === C.monthChoice);
  const month = choice.options.findIndex((o) => o.id === state.choices[choice.key]) + 1;
  const year = Number(typedValue(field(C.yearField)) || field(C.yearField).placeholder) || 2025;
  const days = new Date(year, month, 0).getDate();
  const dayTyped = typedValue(field(C.dayField));
  const day = Math.max(1, Math.min(days, Number(dayTyped || field(C.dayField).placeholder) || 1));
  const fit = calibrate(C, C.font);
  box.replaceChildren();
  for (let d = 1; d <= days; d++) {
    const x = C.columns[(d - 1) % 7], y = C.firstBaseline + Math.floor((d - 1) / 7) * C.rowStep;
    if (d === day) {
      const heart = document.createElementNS(SVG_NS, 'image');
      heart.setAttribute('href', asset(C.heart.href));
      heart.setAttribute('x', x - C.heart.width / 2); heart.setAttribute('y', y + C.heart.dy - C.heart.height / 2);
      heart.setAttribute('width', C.heart.width); heart.setAttribute('height', C.heart.height);
      heart.setAttribute('opacity', dayTyped ? '1' : '0.35');
      box.appendChild(heart);
    }
    const t = document.createElementNS(SVG_NS, 'text');
    t.textContent = String(d).padStart(2, '0');
    t.setAttribute('x', x); t.setAttribute('y', y);
    t.setAttribute('text-anchor', 'middle');
    t.setAttribute('font-family', schriftAttr(C.font)); t.setAttribute('font-size', fit.size);
    t.setAttribute('fill', d === day ? '#fff' : '#000');
    box.appendChild(t);
  }
}

function renderComposedLine(L) {
  const up = (text) => (L.uppercase ? text.toLocaleUpperCase('de-DE') : text);
  const parts = L.text.split(/(\{[^}]+\})/).filter(Boolean).map((part) => {
    const m = part.match(/^\{([^|}]+)(?:\|(.+))?\}$/);
    if (!m) return { text: part, fixed: true };
    // Platzhalter können auch eine Auswahl nennen (z. B. {Monat}): dann steht dort der Wert der gewählten Kachel.
    const choice = TEMPLATE.choices.find((c) => c.key === m[1]);
    if (choice) return { text: up(choice.options.find((o) => o.id === state.choices[choice.key]).value), typed: true };
    const f = TEMPLATE.fields.find((x) => x.key === m[1]);
    const typed = typedValue(f);
    /*
     Zusatz hinter dem Feldnamen, z. B. {Geburtsdatum|vorn}: nur ein Teil der Eingabe.
     initial = erster Buchstabe, vorn = alles bis auf das letzte Wort, letztes = das letzte Wort (bei nur einem
     Wort leer), 1/2/3 = das erste, zweite, dritte Wort. So lässt sich eine Eingabe auf mehrere Zeilen verteilen.
    */
    // Felder mit automatischem Wert (z. B. Koordinaten zur Stadt) zählen wie eingegeben.
    const auto = !typed && f.auto && f.autoValue ? f.autoValue : '';
    const words = (typed || auto || f.placeholder).trim().split(/\s+/);
    const pick = { initial: () => [...words[0]][0] || '', vorn: () => (words.length > 1 ? words.slice(0, -1).join(' ') : words[0]), letztes: () => (words.length > 1 ? words[words.length - 1] : ''),
      // Datum mit Punkten: datum1 = Tag und Monat ("12.01."), datum2 = das Jahr dahinter.
      datum1: () => { const all = words.join(' '); const i = all.lastIndexOf('.'); return i > 0 ? all.slice(0, i + 1) : all; },
      datum2: () => { const all = words.join(' '); const i = all.lastIndexOf('.'); return i > 0 ? all.slice(i + 1).trim() : ''; } };
    const value = !m[2] ? (typed || auto || f.placeholder) : pick[m[2]] ? pick[m[2]]() : words[Number(m[2]) - 1] || '';
    return { text: up(value), typed: Boolean(typed || auto), empty: !typed && !auto && L.dropEmpty };
  });
  // Zeilen ganz ohne Platzhalter (festes Zeichen, das über anderen Zeilen liegen muss) sind immer voll sichtbar.
  const anyTyped = parts.some((p) => p.typed) || parts.every((p) => p.fixed);
  // dropEmpty: nicht ausgefüllte Platzhalter entfallen ganz (freiwillige Zusatznamen), sobald etwas eingegeben ist.
  const shown = anyTyped && L.dropEmpty ? parts.filter((p) => !p.empty) : parts;
  const full = shown.map((p) => (p.fixed ? up(p.text) : p.text)).join('').replace(/\s+/g, ' ').trim();
  const font = fontFor(full, L.font);
  const fit = calibrate(L, font);
  let size = fit.size;
  const width = lineWidth(full, font, size, fit.tracking, L.weight);
  if (L.maxWidth && width > L.maxWidth) size *= L.maxWidth / width;
  const t = L.el;
  t.replaceChildren(...shown.map((p) => {
    const span = document.createElementNS(SVG_NS, 'tspan');
    span.textContent = p.fixed ? up(p.text) : p.text;
    span.setAttribute('opacity', p.typed || (p.fixed && anyTyped) ? '1' : '0.35');
    return span;
  }));
  const anchor = L.anchor || 'middle';
  t.setAttribute('font-family', schriftAttr(font));
  t.setAttribute('font-weight', L.weight || 400);
  t.setAttribute('font-size', size);
  t.setAttribute('letter-spacing', fit.tracking * size);
  t.setAttribute('text-anchor', anchor);
  // fillChoice: Die Farbe der Zeile kommt aus einer Auswahl (color der gewählten Kachel).
  const picked = L.fillChoice && TEMPLATE.choices.find((c) => c.key === L.fillChoice);
  t.setAttribute('fill', (picked && (picked.options.find((o) => o.id === state.choices[picked.key]) || {}).color) || L.fill || '#000');
  // Der Abstand hinter dem letzten Zeichen zählt bei der Ausrichtung mit, deshalb gegenrechnen.
  const x = (L.x != null ? L.x : TEMPLATE.page[0] / 2) + (anchor === 'middle' ? fit.tracking * size / 2 : anchor === 'end' ? fit.tracking * size : 0);
  t.setAttribute('x', x);
  t.setAttribute('y', L.baseline);
  /*
   inkBox [links, oben, rechts, unten]: Die Tinte des Textes wird in diesen Rahmen gesetzt, unten aufsitzend und
   waagerecht mittig, notfalls verkleinert. Für den großen Anfangsbuchstaben: Buchstaben mit Unterlänge (J, Q)
   oder großer Breite (M, W) sitzen so trotzdem sauber, ohne in die Zeilen darunter zu ragen.
  */
  if (L.inkBox) {
    const [bl, bt, br, bb] = L.inkBox;
    const ink = inkBounds(full, size, font, L.weight || 400);
    const k = Math.min(1, (br - bl) / (ink.maxX - ink.minX || 1), (bb - bt) / (ink.maxY - ink.minY || 1));
    t.setAttribute('font-size', size * k);
    t.setAttribute('text-anchor', 'start');
    t.setAttribute('x', (bl + br) / 2 - k * (ink.minX + ink.maxX) / 2);
    t.setAttribute('y', bb - k * ink.maxY);
  }
  // stretchY: in der Höhe gestreckte Schrift (wie in der Photoshop-Vorlage), um die Grundlinie herum.
  if (L.stretchY && L.stretchY !== 1) t.setAttribute('transform', `translate(0 ${L.baseline}) scale(1 ${L.stretchY}) translate(0 ${-L.baseline})`);
  t.dataset.typed = anyTyped ? '1' : '';
  // optional: Die Zeile erscheint erst mit einer Eingabe (sonst sähe ihr Beispieltext wie bestellt aus).
  if (L.optional) t.style.display = anyTyped ? '' : 'none';
}

/* Setzt die Namen nach der Regel der Vorlage und zentriert danach die Gruppe. */
function renderNames() {
  let [L, T, R, B] = TEMPLATE.drawing;
  const layout = [];
  const nameFields = TEMPLATE.fields.filter((f) => f.kind === 'name');
  TEMPLATE.fields.filter((f) => f.kind === 'zeile').forEach(renderLine);
  TEMPLATE.fields.filter((f) => f.kind === 'handname').forEach(renderHandName);
  (TEMPLATE.lines || []).forEach(renderComposedLine);
  if (TEMPLATE.calendar) renderCalendar();
  /*
   example: Ausgangsansicht aus einem echten Druck der 1-Click-App (Johannes 18.10.2026, Hochzeitshände mit Peter &
   Maria). Solange keines der genannten Felder ausgefüllt ist, zeigt die Vorschau dessen Namen und Datum mit dem von
   Hand gesetzten Verbindungsstück statt der blassen Platzhalter. Ab der ersten Eingabe gilt die normale Vorschau.
  */
  if (TEMPLATE.example) {
    const ex = TEMPLATE.example;
    if (!ex.img) {
      ex.img = document.createElementNS(SVG_NS, 'image');
      ex.img.setAttribute('href', asset(ex.href));
      ex.img.setAttribute('x', 0); ex.img.setAttribute('y', 0);
      ex.img.setAttribute('width', TEMPLATE.page[0]); ex.img.setAttribute('height', TEMPLATE.page[1]);
      $('names').appendChild(ex.img);
    }
    const leer = ex.fields.every((k) => !typedValue(TEMPLATE.fields.find((x) => x.key === k)));
    ex.img.style.display = leer ? '' : 'none';
    ex.fields.forEach((k) => {
      const x = TEMPLATE.fields.find((y) => y.key === k);
      if (x && x.text) x.text.style.display = leer ? 'none' : '';
    });
    // voll: Felder, die im Beispiel nicht blass, sondern wie eingegeben erscheinen (z. B. das Datum 14. Februar 2026).
    (ex.voll || []).forEach((k) => { const x = TEMPLATE.fields.find((y) => y.key === k); if (x && x.text && leer && !typedValue(x)) x.text.setAttribute('opacity', '1'); });
  }
  nameFields.forEach((f) => {
    const typed = typedValue(f);
    f.activeFont = fontFor(typed || f.placeholder, TEMPLATE.fontFamily);
    const shown = previewText(typed || f.placeholder, f.activeFont);
    const value = shown.text;
    fieldInfo(f, typed ? shown.replaced : [], typed ? shown.script : null);
    f.text.setAttribute('font-family', schriftAttr(f.activeFont));
    const { tx, ty, box } = PLACEMENT[f.rule](f, value);
    L = Math.min(L, box[0]); T = Math.min(T, box[1]); R = Math.max(R, box[2]); B = Math.max(B, box[3]);
    const t = f.text;
    t.textContent = value;
    t.setAttribute('opacity', typed ? '1' : '0.35');
    t.setAttribute('transform', `translate(${tx} ${ty}) rotate(${-f.angle})`);
    layout.push({ key: f.key, value, box });
  });
  // Zentriert wird erst, wenn alle Namen eingegeben sind. Bis dahin bleibt die Zeichnung ruhig an ihrem Platz.
  const complete = nameFields.every((f) => typedValue(f));
  /*
   Die Schriftgröße bleibt fest, verkleinert wird immer das ganze Motiv (Zeichnung und Namen) proportional.
   Ohne Passepartout: sobald oben und unten weniger als der Mindestabstand zum Blattrand bliebe.
   Mit Passepartout: so, dass die Gruppe auf allen Seiten den Mindestabstand zur Passepartout-Kante hält.
  */
  const [PW, PH] = TEMPLATE.page;
  const fitFor = (pp, marginCm = TEMPLATE.passepartoutMarginCm) => {
    let availW = TEMPLATE.edgeMarginX ? PW - 2 * TEMPLATE.edgeMarginX : Infinity;
    let availH = PH - 2 * TEMPLATE.edgeMargin;
    if (pp) {
      const pxX = PW / pp.sheet[0], pxY = PH / pp.sheet[1];
      const v = TEMPLATE.passepartoutVisualScale;
      availW = PW - 2 * (pp.side * v + marginCm) * pxX;
      availH = PH - 2 * (pp.top * v + TEMPLATE.passepartoutMarginCm) * pxY;
    }
    // fixedLayout: Motive mit festem Aufbau (Hochzeitshände) werden ohne Passepartout nie verschoben.
    const fit = (complete && !TEMPLATE.fixedLayout) || Boolean(pp) || Boolean(TEMPLATE.centerAlways);
    /*
     passepartoutBleedTopCm: Das Motiv läuft oben unter das Passepartout (Arme bei "Wo alles begann"), statt mit Abstand
     im Fenster zu enden. Es wird dafür größer gezeigt: oben ragt es um diesen Wert unter den Karton, unten bleibt der
     normale Abstand zur Kante.
    */
    if (pp && TEMPLATE.passepartoutBleedTopCm != null) {
      const pxY = PH / pp.sheet[1];
      const top = (pp.top * TEMPLATE.passepartoutVisualScale - TEMPLATE.passepartoutBleedTopCm) * pxY;
      const bottom = PH - (pp.top * TEMPLATE.passepartoutVisualScale + TEMPLATE.passepartoutMarginCm) * pxY;
      const kTop = Math.min(1, availW / (R - L), (bottom - top) / (B - T));
      return { k: kTop, dx: PW / 2 - kTop * (L + R) / 2, dy: top - kTop * T };
    }
    const k = fit ? Math.min(1, availW / (R - L), availH / (B - T)) : 1;
    return { k, dx: fit ? PW / 2 - k * (L + R) / 2 : 0, dy: fit ? centerY - k * (T + B) / 2 : 0 };
  };
  const sizePp = previewPassepartout();
  const pp = state.pp ? sizePp : null;
  const { k, dx, dy } = fitFor(pp);
  $('group').style.transform = `translate(${dx}px, ${dy}px) scale(${k})`;
  // Die Passepartout-Kacheln zeigen dasselbe Motiv live, einmal ohne und einmal mit Einlage.
  // Die Kacheln zeigen nur die wirklich eingegebenen Namen, keine Beispielnamen. Ausgerichtet wird trotzdem
  // an der voll ausgefüllten Vorschau (Beispielnamen mitgerechnet), damit beim Tippen nichts springt.
  $('names-typed').replaceChildren(...TEMPLATE.fields
    .filter((f) => f.text && isShown(f) && typedValue(f))
    .map((f) => f.text.cloneNode(true)),
    ...(TEMPLATE.lines || []).filter((L) => L.el.dataset.typed).map((L) => L.el.cloneNode(true)),
    ...(TEMPLATE.calendar ? [TEMPLATE.calendar.el.cloneNode(true)] : []));
  ROOT.querySelectorAll('.mini g[data-pp]').forEach((g) => {
    const f = g.dataset.pp === '1' ? fitFor(sizePp, TEMPLATE.passepartoutTileMarginCm) : fitFor(null);
    g.setAttribute('transform', `translate(${f.dx} ${f.dy}) scale(${f.k})`);
  });
  window.__layout = { complete, pp: Boolean(pp), scale: k, dx, dy, group: [L, T, R, B], names: layout.map((n) => ({ ...n, box: n.box.map((v, i) => v * k + (i % 2 ? dy : dx)) })) };
}

function tiles(container, items, isActive, onPick) {
  container.innerHTML = '';
  items.forEach((it) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'tile' + ((it.swatch || it.swatchHtml) ? ' tile--image' : '');
    b.innerHTML = (it.swatchHtml || (it.swatch ? `<span class="swatch ${it.swatch}"></span>` : '')) + it.label + (it.sub ? `<small>${it.sub}</small>` : '');
    b.setAttribute('aria-pressed', isActive(it) ? 'true' : 'false');
    if (it.disabled) b.disabled = true;
    b.addEventListener('click', () => { onPick(it); render(); });
    container.appendChild(b);
  });
}

function currentSize() { return TEMPLATE.sizes.find((s) => s.id === state.size); }

/*
 Maße des Passepartouts für die VORSCHAU. Johannes will, dass die Vorschau beim Wechsel zwischen A4 und 30 x 40 nicht
 springt: gezeigt wird deshalb immer dasselbe Passepartout (passepartoutPreview, die A4-Maße). Ob es die Einlage in
 der gewählten Größe überhaupt gibt, entscheidet weiter die Größe selbst.
*/
function previewPassepartout() {
  const own = currentSize().passepartout;
  return own ? (TEMPLATE.passepartoutPreview || own) : null;
}

/* Preis des Passepartouts in der gewählten Größe. Im Shop gilt der Preis der Variante des Artikels (ENV.ppPrices). */
function ppPrice() {
  const s = currentSize();
  if (ENV.ppPrices && ENV.ppPrices[s.id] != null) return ENV.ppPrices[s.id];
  return (s.passepartout && s.passepartout.price) || TEMPLATE.passepartoutPrice;
}

/* Grußkarten als Zusatzangebot (z. B. bei Motiven zu Liebe, Hochzeit, Familie). Im Shop legt das Theme fest, ob und
   welche Karten angeboten werden (ENV.cards: Liste aus label, note, image, price). Im Prototyp zeigt ?karte=1 ein Beispiel.
   state.cards merkt sich die angehakten Karten als Positionen in dieser Liste. */
const CARDS = ENV.onAdd ? (ENV.cards || []) : (new URLSearchParams(location.search).get('karte') ? [
  { label: 'Geschenkkarte hinzufügen', note: '„Just Married“ · edle Leinenstruktur, mit Umschlag', price: 3.99, image: 'https://cdn.shopify.com/s/files/1/0940/6601/6520/files/1_Karten_1.jpg?v=1770223811&width=120' },
  { label: 'Geschenkkarte hinzufügen', note: '„Das Wertvollste im Leben“ · edle Leinenstruktur, mit Umschlag', price: 3.99, image: 'https://cdn.shopify.com/s/files/1/0940/6601/6520/files/1_Karten.jpg?v=1770224079&width=120' }
] : []);

function total() {
  const s = currentSize();
  let sum = s.price;
  if (state.frame !== 'ohne') sum += s.framePrice;
  if (state.frame !== 'ohne' && state.pp) sum += ppPrice();
  if (state.frame !== 'ohne' && state.hook) sum += TEMPLATE.hook.price;
  state.cards.forEach((i) => { sum += CARDS[i].price; });
  return sum;
}

/*
 Mehrere Poster in einem Fenster (16.10.2026), nur bei der Vorlage "standard" (Poster ohne Personalisierung).
 Die Produktseite (Abschnitt juhmi-set-serie) stellt window.JUHMI_GRUPPE bereit:
 - set.posters und setModus: "Als Set" gewählt, das Fenster zeigt alle Poster des Sets ("für dein Set")
 - auswahl: zusätzlich angehakte Poster der Serie, das Fenster zeigt das aktuelle Poster und diese ("für deine Auswahl")
 Größe, Rahmen, Passepartout und Bilderhaken gelten dann für alle gewählten Poster. Große Sets (Poster mit gr) haben
 statt der Größe eine Formation: Groß = jedes Poster in gr[0], Klein = gr[1]. Ohne JUHMI_GRUPPE oder ohne Set und
 Auswahl bleibt alles beim einzelnen Poster.
 Preise und Warenkorb kommen vom Theme: ENV.posterPrices(varianten), ENV.loadPoster(handle), ENV.onAddMulti(auswahl).
*/
const SIZE_CM = { A5: [14.8, 21], A4: [21, 29.7], A3: [29.7, 42] };
const SIZE_ORDER = ['A3', 'A4', 'A5'];
const multi = { kind: null, key: '', posters: [], formation: 0, hookPacks: null };
/*
 Bilderhaken bei mehreren Postern: ein Haken je Bild reicht, ein Päckchen hat zwei. Vorauswahl daher Poster / 2,
 aufgerundet (2er-Set 1, 3er 2, 5er und 6er 3, 7er 4). Der Kunde kann mit − / + ändern (multi.hookPacks).
 Preis je Anzahl aus den Haken-Varianten des Shops (ENV.hookTiers), sonst aus der Vorlage (tiers, tierExtra).
*/
function hookPacks(n) { return Math.max(1, multi.hookPacks || Math.ceil(n / 2)); }
function hookPreis(k) {
  const tiers = ENV.hookTiers || TEMPLATE.hook.tiers;
  if (!tiers) return k * TEMPLATE.hook.price;
  if (tiers[k] != null) return tiers[k];
  const max = Math.max(...Object.keys(tiers).map(Number));
  return tiers[max] + (k - max) * (TEMPLATE.hook.tierExtra || TEMPLATE.hook.price);
}
const TICK = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.5 L6.5 12 L13 4.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="square"/></svg>';
const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const imgW = (url, w) => (url ? (url.indexOf('//') === 0 ? 'https:' + url : url) + (url.indexOf('?') < 0 ? '?' : '&') + 'width=' + w : '');
function gruppe() { return TEMPLATE_NAME === 'standard' && window.JUHMI_GRUPPE ? window.JUHMI_GRUPPE : null; }
function multiMode() {
  const G = gruppe();
  if (!G) return null;
  if (G.set && G.setModus) return 'set';
  if (G.auswahl && G.auswahl.length) return 'auswahl';
  return null;
}
/* Stellt die Poster für den Modus zusammen. Dieselbe Zusammenstellung behält ihre Häkchen und die Formation. */
function setupMulti(kind) {
  multi.kind = kind;
  if (!kind) return;
  const G = gruppe();
  let list;
  if (kind === 'set') list = G.set.posters.map((p) => ({ h: p.h, t: p.t, img: p.img, gr: p.gr, variants: p.variants }));
  else {
    const info = (h) => ((G.serie && G.serie.posters) || []).find((p) => p.h === h) || { h };
    list = [G.aktuell].concat(G.auswahl.filter((h) => h !== G.aktuell)).map((h) => { const p = info(h); return { h, t: p.t || '', img: p.img || '', variants: null }; });
  }
  const key = `${kind}:${list.map((p) => p.h).join(',')}`;
  if (multi.key !== key) {
    multi.key = key;
    multi.formation = 0;
    multi.hookPacks = null;
    multi.posters = list.map((p) => ({ ...p, on: true }));
  }
  multi.posters.forEach((p) => {
    // Das aktuelle Poster mit den Preisen der Produktseite (eine laufende Aktion ist dort schon eingerechnet).
    if (p.h === G.aktuell && ENV.variants && p.variants !== ENV.variants) { p.variants = ENV.variants; p.prices = null; }
    if (p.variants || p.loading || p.failed) return;
    if (!ENV.loadPoster) { p.failed = true; p.on = false; return; }
    // Varianten der Serien-Poster holen (Ladezustand in Liste, Vorschau und Knopf).
    p.loading = true;
    ENV.loadPoster(p.h).then((d) => {
      p.variants = d.variants; p.prices = null; p.loading = false;
      if (!p.t) p.t = d.title;
      if (!p.img) p.img = d.image;
      render();
    }).catch((error) => {
      p.loading = false; p.failed = true; p.on = false;
      render();
      console.error(error);
    });
  });
}
/* Preise eines Posters je Größe in Euro: { A4: { price, frame } }. Ohne Shop: die Preise der Vorlage. */
function posterPrices(p) {
  if (!p.variants) return null;
  if (!p.prices) {
    p.prices = ENV.posterPrices ? ENV.posterPrices(p.variants) : {};
    if (!ENV.posterPrices) TEMPLATE.sizes.forEach((s) => { p.prices[s.id] = { price: s.price, frame: s.framePrice }; });
  }
  return p.prices;
}
/* Größe eines Posters: Formation (gr) oder die gewählte Größe; fehlt sie dem Poster, die nächste vorhandene. */
function sizeFor(p) {
  const want = p.gr ? p.gr[multi.formation] || p.gr[0] : state.size;
  const pr = posterPrices(p);
  if (!pr || pr[want]) return want;
  return ['A4', 'A3', 'A5'].find((s) => pr[s]) || want;
}
function ppPriceOf(size) {
  if (ENV.ppPrices && ENV.ppPrices[size] != null) return ENV.ppPrices[size];
  const pp = TEMPLATE.frameSizes[size] && TEMPLATE.frameSizes[size].passepartout;
  return (pp && pp.price) || TEMPLATE.passepartoutPrice;
}
/* Eine Zeile je gewähltem Poster mit Größe und Preisen (Poster, Rahmen, Passepartout). */
function multiLines(frameId = state.frame, withPp = state.pp) {
  return multi.posters.filter((p) => p.on && p.variants).map((p) => {
    const size = sizeFor(p);
    const pr = posterPrices(p)[size] || {};
    const fs = TEMPLATE.frameSizes[size] || {};
    const framed = frameId !== 'ohne';
    const ppOk = framed && withPp && Boolean(fs.passepartout);
    return {
      p, size, price: pr.price || 0,
      frame: framed ? (pr.frame != null ? pr.frame : fs.framePrice || 0) : 0,
      ppOk, pp: ppOk ? ppPriceOf(size) : 0,
    };
  });
}
/* Mengenstaffel aus der Produktseite: [{ ab, prozent }], z. B. ab 3 Postern 10 %, ab 5 Postern 15 %. */
function staffel() { return (gruppe().staffel || []).slice().sort((a, b) => a.ab - b.ab); }
function staffelFuer(n) { return staffel().filter((s) => n >= s.ab).reduce((m, s) => Math.max(m, s.prozent), 0); }
function multiTotal() {
  const lines = multiLines();
  const base = lines.reduce((sum, l) => sum + l.price + l.frame + l.pp, 0);
  const hooks = state.frame !== 'ohne' && state.hook ? hookPreis(hookPacks(lines.length)) : 0;
  const cards = state.cards.reduce((sum, i) => sum + CARDS[i].price, 0);
  const G = gruppe();
  /*
   Rabatt (Anzeige, der echte kommt als automatischer Shopify-Rabatt): Set-Rabatt, wenn alle Poster des Sets gewählt
   sind, sonst die Mengenstaffel (z. B. ab 3 Postern 10 %, ab 5 Postern 15 %). Nicht addiert, der bessere gilt.
   Nur auf Poster und Rahmen (Variante), Passepartout und Haken sind eigene Artikel ohne Rabatt.
  */
  const setRabatt = multi.kind === 'set' && G.set && G.set.rabatt > 0 && multi.posters.every((p) => p.on) ? G.set.rabatt : 0;
  const mengen = staffelFuer(lines.length);
  const rabatt = Math.max(setRabatt, mengen);
  const basis = lines.reduce((sum, l) => sum + l.price + l.frame, 0);
  const reduced = rabatt ? Math.round(basis * (100 - rabatt)) / 100 + (base - basis) : base;
  return { lines, n: lines.length, full: base + hooks + cards, sum: reduced + hooks + cards, rabatt, alsSet: setRabatt > 0 && setRabatt >= mengen };
}
/* "+ 10,00 € je Poster", bei unterschiedlichen Preisen "+ ab 10,00 € je Poster". */
function perPoster(values) {
  const list = values.filter((v) => v > 0);
  if (!list.length) return '';
  const min = Math.min(...list), max = Math.max(...list);
  return `+ ${min === max ? '' : 'ab '}${euro(min)} je Poster`;
}
/* Formation als Text, z. B. "2× A3 + 4× A4". */
function formationText(index) {
  const count = {};
  multi.posters.forEach((p) => { const s = p.gr ? p.gr[index] || p.gr[0] : state.size; count[s] = (count[s] || 0) + 1; });
  return SIZE_ORDER.filter((s) => count[s]).map((s) => `${count[s]}× ${s}`).join(' + ');
}

/*
 Vorschau mit mehreren Postern. Maße in cm (A5 14,8 x 21, A4 21 x 29,7, A3 29,7 x 42), alles mit demselben Faktor
 verkleinert. Ohne Formation stehen die Poster in einer Reihe (bei vielen Postern in zwei oder drei Reihen, je
 nachdem, was größer wirkt). Große Sets als Bilderwand: die großen Poster in der Mitte untereinander, die übrigen in
 zwei Spalten links und rechts.
*/
function renderWall() {
  const wall = $('wall');
  const shown = multi.posters.filter((p) => !p.failed);
  if (wall.dataset.key !== multi.key || wall.children.length !== shown.length) {
    wall.dataset.key = multi.key;
    wall.innerHTML = shown.map((p) => `<div class="wp" data-h="${esc(p.h)}"><span class="wp__mat"><span class="wp__win"><img alt="" draggable="false"></span></span></div>`).join('');
  }
  const pp = TEMPLATE.passepartoutPreviewHoch || TEMPLATE.passepartoutPreview;
  if (pp) {
    const v = TEMPLATE.passepartoutVisualScale;
    wall.style.setProperty('--ppx', v * pp.side / pp.sheet[0]);
    wall.style.setProperty('--ppy', v * pp.top / pp.sheet[1]);
  }
  Array.from(wall.children).forEach((el, i) => {
    const p = shown[i];
    const size = sizeFor(p);
    el.dataset.frame = state.frame;
    el.dataset.pp = state.frame !== 'ohne' && state.pp && TEMPLATE.frameSizes[size] && TEMPLATE.frameSizes[size].passepartout ? '1' : '0';
    el.dataset.off = p.on ? '0' : '1';
    el.dataset.size = size;
    const img = el.querySelector('img');
    const src = imgW(p.img, 500);
    if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
    img.style.visibility = src ? '' : 'hidden';
    // Querformat erkennt die Wand am geladenen Bild: Rahmen quer, Platz neu verteilen.
    img.onload = () => { const q = img.naturalWidth > img.naturalHeight ? '1' : '0'; if (el.dataset.quer !== q) { el.dataset.quer = q; layoutWall(); } };
    if (img.complete && img.naturalWidth) img.onload();
  });
  layoutWall();
}
function layoutWall() {
  const wall = $('wall');
  const W = wall.clientWidth, H = wall.clientHeight;
  if (!multi.kind || !W || !H) return;
  const els = Array.from(wall.children);
  const items = els.map((el) => { const [w, h] = SIZE_CM[el.dataset.size] || SIZE_CM.A4; return el.dataset.quer === '1' ? { el, w: h, h: w } : { el, w, h }; });
  if (!items.length) return;
  const gap = 4; // Abstand zwischen den Postern in cm
  const stack = (list) => ({ list, w: Math.max(...list.map((x) => x.w)), h: list.reduce((s, x) => s + x.h, 0) + gap * (list.length - 1) });
  let best = null;
  const tryLayout = (columns, rows) => {
    // columns: Spalten mit untereinander stehenden Postern; rows: Reihen mit nebeneinander stehenden Postern.
    let w, h;
    if (columns) { w = columns.reduce((s, c) => s + c.w, 0) + gap * (columns.length - 1); h = Math.max(...columns.map((c) => c.h)); }
    else { w = Math.max(...rows.map((r) => r.w)); h = rows.reduce((s, r) => s + r.h, 0) + gap * (rows.length - 1); }
    const k = Math.min(W / w, H / h) * 0.97;
    // Nebeneinander ist gewünscht: weitere Reihen nur, wenn die Poster dadurch deutlich größer werden. Bei Querformaten
    // (nur Spalten) entsprechend: weitere Spalten nur bei deutlich größeren Postern. Die Mitte-Anordnung probiert nur eine.
    const score = k * Math.pow(0.6, (rows || columns).length - 1);
    if (!best || score > best.score) best = { k, score, columns, rows, w, h };
  };
  const shown = multi.posters.filter((p) => !p.failed);
  const biggest = SIZE_ORDER.find((s) => shown.some((p) => p.gr && p.gr[0] === s));
  const center = biggest ? items.filter((x, i) => shown[i] && shown[i].gr && shown[i].gr[0] === biggest) : [];
  if (center.length && center.length < items.length) {
    const rest = items.filter((x) => !center.includes(x));
    const left = rest.slice(0, Math.floor(rest.length / 2)), right = rest.slice(Math.floor(rest.length / 2));
    tryLayout([left, center, right].filter((c) => c.length).map(stack));
  } else if (items.every((x) => x.w > x.h)) {
    // Nur Querformate (22.10.2026, Johannes): untereinander statt nebeneinander. Weitere Spalten nur, wenn die Poster
    // dadurch deutlich größer werden (wie bei den Reihen).
    for (let c = 1; c <= Math.min(3, items.length); c++) {
      const per = Math.ceil(items.length / c);
      const columns = [];
      for (let i = 0; i < items.length; i += per) columns.push(stack(items.slice(i, i + per)));
      tryLayout(columns, null);
    }
  } else {
    for (let r = 1; r <= Math.min(3, items.length); r++) {
      const per = Math.ceil(items.length / r);
      const rows = [];
      for (let i = 0; i < items.length; i += per) {
        const list = items.slice(i, i + per);
        rows.push({ list, w: list.reduce((s, x) => s + x.w, 0) + gap * (list.length - 1), h: Math.max(...list.map((x) => x.h)) });
      }
      tryLayout(null, rows);
    }
  }
  const { k } = best;
  const x0 = (W - best.w * k) / 2, y0 = (H - best.h * k) / 2;
  const place = (x, y, it) => Object.assign(it.el.style, { left: `${x}px`, top: `${y}px`, width: `${it.w * k}px`, height: `${it.h * k}px` });
  if (best.columns) {
    let x = x0;
    best.columns.forEach((c) => {
      let y = y0 + (best.h - c.h) * k / 2;
      c.list.forEach((it) => { place(x + (c.w - it.w) * k / 2, y, it); y += (it.h + gap) * k; });
      x += (c.w + gap) * k;
    });
  } else {
    let y = y0;
    best.rows.forEach((r) => {
      let x = x0 + (best.w - r.w) * k / 2;
      r.list.forEach((it) => { place(x, y + (r.h - it.h) * k / 2, it); x += (it.w + gap) * k; });
      y += (r.h + gap) * k;
    });
  }
}

/* Optionen, Titel und Fußzeile im Mehrfach-Modus bzw. zurück zum einzelnen Poster. */
let baseTitle = '';
let multiLocked = false;
function renderMulti() {
  const M = multi.kind;
  const G = gruppe();
  ROOT.querySelector('.modal').classList.toggle('modal--multi', Boolean(M));
  $('modal-title').textContent = M === 'set' ? 'Rahmen und Zubehör für dein Set' : M === 'auswahl' ? 'Rahmen und Zubehör für deine Auswahl' : baseTitle;
  $('multi-group').hidden = !M;
  const formation = Boolean(M) && multi.posters.some((p) => p.gr);
  $('formation-group').hidden = !formation;
  $('size-group').hidden = formation;
  $('size-label').textContent = M ? '· für alle' : '';
  $('pp-label').textContent = M ? '· für alle' : '';
  // Hinweis auf das Set beim einzelnen Poster.
  const hint = !M && G && G.set ? G.set : null;
  $('set-hint').hidden = !hint;
  if (hint && $('set-hint').dataset.key !== hint.name) {
    $('set-hint').dataset.key = hint.name;
    $('set-hint-stack').innerHTML = hint.posters.slice(0, 3).map((p) => `<img src="${esc(imgW(p.img, 80))}" alt="">`).join('');
    $('set-hint-text').textContent = `Gehört zu einem ${hint.posters.length}er-Set` + (hint.rabatt > 0 ? `, zusammen ${hint.rabatt} % günstiger` : '');
  }
  if (!M) {
    $('hook-stepper').hidden = true;
    $('hook-label').innerHTML = `${TEMPLATE.hook.label}<small>${TEMPLATE.hook.note}</small>`;
    $('hook-price').textContent = `+ ${euro(TEMPLATE.hook.price)}`;
    $('save').className = 'save';
    $('add-n').textContent = '';
    if (multiLocked) { $('add').disabled = false; multiLocked = false; }
    return;
  }
  $('multi-title').innerHTML = `${M === 'set' ? 'Poster im Set' : 'Deine Auswahl'} <span>· abwählen möglich</span>`;
  // Liste der Poster. Der Fokus bleibt beim Neuaufbau auf demselben Eintrag.
  const focused = ROOT.activeElement && ROOT.activeElement.closest && ROOT.activeElement.closest('.pick');
  const focusIndex = focused ? Number(focused.dataset.i) : -1;
  const onCount = multi.posters.filter((p) => p.on).length;
  $('picks').innerHTML = multi.posters.map((p, i) => {
    const status = p.failed ? 'nicht verfügbar' : p.loading ? 'lädt …' : sizeFor(p);
    return `<button type="button" class="pick" role="checkbox" data-i="${i}" aria-checked="${p.on ? 'true' : 'false'}"${p.failed ? ' disabled' : ''}>`
      + `<span class="pick__box">${TICK}</span>${p.img ? `<img src="${esc(imgW(p.img, 80))}" alt="">` : '<img alt="">'}`
      + `<span class="pick__name">${esc(p.t)}</span><span class="pick__size">${esc(status)}</span></button>`;
  }).join('');
  ROOT.querySelectorAll('#picks .pick').forEach((b) => b.addEventListener('click', () => {
    const p = multi.posters[Number(b.dataset.i)];
    // Mindestens ein Poster bleibt gewählt.
    if (p.on && onCount <= 1) return;
    p.on = !p.on;
    render();
  }));
  if (focusIndex >= 0) { const b = ROOT.querySelector(`#picks .pick[data-i="${focusIndex}"]`); if (b) b.focus({ preventScroll: true }); }
  if (formation) {
    // Sets mit nur einer Größe je Poster (z. B. Pampasgras: 2× A3, 3× A4, 2× A5) haben keine Wahl Groß/Klein.
    const zwei = multi.posters.some((p) => p.gr && p.gr[1]);
    tiles($('formation'), (zwei ? [0, 1] : [0]).map((i) => ({ id: i, label: `<strong>${zwei ? (i ? 'Klein' : 'Groß') : 'Bilderwand'}</strong>`, sub: formationText(i) })), (x) => x.id === multi.formation, (x) => { multi.formation = x.id; });
  }
  const t = multiTotal();
  $('total').innerHTML = t.rabatt ? `<s>${euro(t.full)}</s>${euro(t.sum)}` : euro(t.sum);
  let save = '', saveClass = '';
  const naechste = staffel().find((s) => s.ab > t.n && s.prozent > t.rabatt);
  if (t.rabatt) { save = t.alsSet ? `${multi.posters.length}er-Set: ${t.rabatt} % gespart` : `${t.rabatt} % Mengenrabatt`; saveClass = 'save--badge'; }
  else if (naechste) { const k = naechste.ab - t.n; save = `Noch ${k} Poster bis ${naechste.prozent} % Rabatt`; saveClass = 'save--hint'; }
  $('save').textContent = save;
  $('save').className = `save ${save ? saveClass : ''}`;
  $('add-n').textContent = `${t.n} Poster `;
  const loading = multi.posters.some((p) => p.on && p.loading);
  if (loading || multiLocked) { $('add').disabled = loading; multiLocked = loading; }
  // Bilderhaken: Anzahl Päckchen wählbar, Mengenpreis.
  const k = hookPacks(t.n);
  const voll = k * TEMPLATE.hook.price, preis = hookPreis(k);
  $('hook-label').innerHTML = `Bilderhaken<small>Ein Haken je Bild reicht, 2 Stück je Päckchen · ${TEMPLATE.hook.note}</small>`;
  // Vergleich mit dem Einzelkauf, kein Streichpreis im Sinne "früher teurer".
  $('hook-price').innerHTML = preis < voll - 0.005 ? `<small>einzeln <s>${euro(voll)}</s></small> + ${euro(preis)}` : `+ ${euro(preis)}`;
  $('hook-stepper').hidden = !(state.frame !== 'ohne' && state.hook);
  $('hook-count').textContent = `${k} ${k === 1 ? 'Päckchen' : 'Päckchen'} (${k * 2} Haken)`;
  $('hook-minus').disabled = k <= 1;
  renderWall();
}

function render() {
  // Die Auflösungsprüfung des Fotos hängt an der gewählten Größe.
  if (TEMPLATE && TEMPLATE.photo && photo.img) renderPhoto();
  const s = currentSize();
  // Mehrere Poster (Set oder Serien-Auswahl): Zeilen je gewähltem Poster, sonst null.
  const multiAll = multi.kind ? multiLines('schwarz', true) : null;
  // Ein Passepartout gibt es nur mit Rahmen und nur in A4 und 30 x 40 cm (bei mehreren Postern: bei mindestens einem).
  const ppPossible = state.frame !== 'ohne' && (multiAll ? multiAll.some((l) => l.ppOk) : Boolean(s.passepartout));
  if (!ppPossible) state.pp = false;
  const hookPossible = state.frame !== 'ohne';
  if (!hookPossible) state.hook = false;

  // Auf der Produktseite steht der Preis schon unter dem Titel, in den Kacheln erscheint er erst im Fenster.
  // A3 kommt in den Rahmen 30 x 40 cm: mit Rahmen heißt die Kachel so (Johannes, 20.10.2026), ohne Rahmen bleibt sie A3.
  const sizeTiles = (withPrice) => TEMPLATE.sizes.map((x) => {
    const big = x.id === 'A3' && state.frame !== 'ohne';
    const sub = big ? 'cm, im Rahmen' : x.sub;
    // Mit Rahmen zeigt die Kachel den Preis inklusive Rahmen (Johannes 20.10.2026, 3A), sonst wirkte "30 x 40, im Rahmen" für 17,95 € zu billig.
    const preis = state.frame !== 'ohne' && x.framePrice ? x.price + x.framePrice : x.price;
    return { ...x, label: `<strong>${big ? '30 x 40' : x.label}</strong>`, sub: withPrice ? `${sub}<b>${euro(preis)}</b>` : sub };
  });
  // Dieselbe Auswahl steht auf der Produktseite und im Fenster, beide greifen auf denselben Zustand zu.
  [[$('sizes'), true], [$('page-sizes'), false]].forEach(([el, withPrice]) => tiles(el, sizeTiles(withPrice), (x) => x.id === state.size, (x) => { state.size = x.id; }));
  $('page-price').textContent = euro(s.price);

  TEMPLATE.choices.forEach((c) => {
    tiles(c.el, c.options, (o) => o.id === state.choices[c.key], (o) => { state.choices[c.key] = o.id; });
    c.options.forEach((o) => {
      const on = o.id === state.choices[c.key];
      if (o.image) o.image.style.display = on ? '' : 'none';
      // motif: Die Auswahl tauscht das ganze Motivbild (z. B. dieselbe Zeichnung in einer anderen Farbe).
      if (o.motif && on) $('motif').setAttribute('href', asset(o.motif));
      if (o.lineField) { renderLine(o.lineField); o.lineField.text.setAttribute('opacity', '1'); o.lineField.text.style.display = on ? '' : 'none'; }
    });
  });
  if (TEMPLATE.panel) {
    const c = TEMPLATE.choices.find((x) => x.key === TEMPLATE.panel);
    const o = c.options.find((x) => x.id === state.choices[c.key]);
    const [x0, y0, x1, y1] = o.rect || [0, 0, TEMPLATE.page[0], TEMPLATE.page[1]];
    const rect = $('panel-rect');
    rect.setAttribute('x', x0); rect.setAttribute('y', y0); rect.setAttribute('width', x1 - x0); rect.setAttribute('height', y1 - y0);
    rect.setAttribute('fill', o.color);
  }
  TEMPLATE.fields.forEach((f) => { if (f.el) f.el.hidden = !isShown(f); });

  const frameTiles = TEMPLATE.frames.map((x) => ({
    ...x,
    swatch: `swatch--${x.id}`,
    sub: x.id === 'ohne' ? 'nur Poster' : `+ ${euro(s.framePrice)}`,
  }));
  // Bei mehreren Postern gilt der Aufpreis je Poster.
  const windowFrameTiles = multiAll ? frameTiles.map((x) => (x.id === 'ohne' ? x : { ...x, sub: perPoster(multiAll.map((l) => l.frame)) })) : frameTiles;
  tiles($('frames'), windowFrameTiles, (x) => x.id === state.frame, (x) => { state.scrollToPp = state.frame === 'ohne' && x.id !== 'ohne'; state.frame = x.id; });
  // Dieselben drei Kacheln stehen auf der Produktseite unter der Größe (im Shop in einem Bereich des Themes).
  // Ein Klick auf einen Rahmen öffnet gleich das Fenster mit diesem Rahmen, dort folgen Passepartout und Zubehör.
  tiles(ENV.pageFrames || $('page-frames'), frameTiles, (x) => x.id === state.frame, (x) => { state.frame = x.id; if (x.id !== 'ohne') openWindow(); });

  // Die Miniatur zeigt den gewählten Rahmen; ohne Rahmen den schwarzen als Beispiel.
  const miniFrame = state.frame === 'weiss' ? 'weiss' : 'schwarz';
  const mini = (pp) => `<span class="swatch swatch--live" data-frame="${miniFrame}" data-pp="${pp}"><span class="mini"><span class="mini__mat">`
    + `<svg viewBox="0 0 ${TEMPLATE.page[0]} ${TEMPLATE.page[1]}" preserveAspectRatio="xMidYMid slice" aria-hidden="true"><g data-pp="${pp}"><use href="#map-layer"/><use href="#motif"/><use href="#overlays"/><use href="#names-typed"/></g></svg>`
    + `<span class="mini__pp"></span></span></span></span>`;
  const shownPp = multiAll ? TEMPLATE.passepartoutPreview : previewPassepartout();
  if (shownPp) {
    const v = TEMPLATE.passepartoutVisualScale;
    $('pps').style.setProperty('--ppx', v * shownPp.side / shownPp.sheet[0]);
    $('pps').style.setProperty('--ppy', v * shownPp.top / shownPp.sheet[1]);
  }
  tiles($('pps'), [
    { id: 0, label: 'Ohne Passepartout', swatchHtml: mini(0), sub: 'nur Rahmen' },
    { id: 1, label: 'Mit Passepartout', swatchHtml: mini(1), sub: multiAll ? perPoster(multiAll.map((l) => l.pp)) : `+ ${euro(ppPrice())}` },
  ], (x) => Boolean(x.id) === state.pp, (x) => { state.pp = Boolean(x.id); });

  $('frame-label').textContent = multiAll ? '· für alle' : state.frame === 'ohne' ? '' : `· ${s.frameLabel}`;
  $('pp-group').style.display = ppPossible ? 'block' : 'none';
  $('hook-group').style.display = hookPossible ? 'block' : 'none';
  $('card-group').style.display = CARDS.length ? 'block' : 'none';
  $('hook-group').parentElement.classList.toggle('options--flush', hookPossible || CARDS.length > 0);
  $('hook').setAttribute('aria-pressed', state.hook ? 'true' : 'false');
  $('card-group').querySelectorAll('.extra').forEach((b, i) => b.setAttribute('aria-pressed', state.cards.includes(i) ? 'true' : 'false'));
  $('frame').dataset.frame = state.frame;
  $('frame').dataset.pp = state.pp ? '1' : '0';
  $('total').textContent = euro(total());
  // Mehrere Poster: eigene Liste, Vorschau und Summe (überschreibt die Summe oben); beim einzelnen Poster der Set-Hinweis.
  renderMulti();
  updatePassepartout();
  if (fieldsBuilt) renderNames();
  if (state.scrollToPp && hookPossible) {
    requestAnimationFrame(() => $('hook-group').scrollIntoView({ behavior: 'smooth', block: 'end' }));
  }
  state.scrollToPp = false;
}

/* Stegbreiten des Passepartouts im richtigen Verhältnis zur Rahmenöffnung. */
function updatePassepartout() {
  if (!TEMPLATE) return; // der ResizeObserver meldet sich schon, bevor die Vorlage geladen ist
  const pp = previewPassepartout();
  if (!pp) return;
  // Rahmenöffnung aus der Rahmenbreite gerechnet (nicht gemessen), damit es auch mitten in einer Animation stimmt.
  const fw = $('frame').getBoundingClientRect().width;
  // Leiste: 3,25 % der kurzen Seite (beim Querformat ist die Breite die lange Seite).
  const bar = fw * 0.0325 * Math.min(...TEMPLATE.page) / TEMPLATE.page[0];
  const w = fw - 2 * bar;
  const h = fw * TEMPLATE.page[1] / TEMPLATE.page[0] - 2 * bar;
  const v = TEMPLATE.passepartoutVisualScale;
  const y = h * v * pp.top / pp.sheet[1];
  const x = w * v * pp.side / pp.sheet[0];
  // Karton mit Loch: äußeres Rechteck und Fenster als ein Pfad, das Fenster bleibt durch die Füllregel frei.
  $('pp').style.clipPath = `polygon(evenodd, 0 0, ${w}px 0, ${w}px ${h}px, 0 ${h}px, 0 0, ${x}px ${y}px, ${x}px ${h - y}px, ${w - x}px ${h - y}px, ${w - x}px ${y}px, ${x}px ${y}px)`;
  // Breite des Schrägschnitts im Verhältnis zum Rahmen (rund 2 mm bei A4). Der Schnitt gehört zum Karton,
  // deshalb sitzt er außen um das Fenster herum.
  const bevel = Math.max(2.5, fw * 0.0095);
  Object.assign($('pp-edge').style, {
    left: `${x - bevel}px`, top: `${y - bevel}px`,
    width: `${w - 2 * x + 2 * bevel}px`, height: `${h - 2 * y + 2 * bevel}px`,
    borderWidth: `${bevel}px`,
  });
}

function validate() {
  let ok = true;
  TEMPLATE.fields.forEach((f) => {
    // Der Ort gilt erst als ausgefüllt, wenn er gefunden wurde und die Karte dazu steht.
    const missing = f.kind === 'ort' && typedValue(f) && !(mapState.found && mapState.query === typedValue(f));
    f.el.querySelector('.err').textContent = missing ? 'Zu diesem Ort gibt es noch keine Karte. Bitte prüfe die Adresse.' : 'Dieses Feld ist erforderlich';
    // Zahlenfelder mit Grenzen (z. B. Geburtstag 18 bis 99).
    const outOfRange = f.format === 'zahl' && typedValue(f) && (Number(typedValue(f)) < (f.min || 0) || Number(typedValue(f)) > (f.maxValue || Infinity));
    if (outOfRange) f.el.querySelector('.err').textContent = `Bitte eine Zahl von ${f.min} bis ${f.maxValue} eingeben.`;
    const empty = Boolean(isShown(f) && f.required && !typedValue(f)) || Boolean(missing) || Boolean(outOfRange);
    f.el.classList.toggle('invalid', empty);
    if (empty && ok) f.el.querySelector('input').focus();
    if (empty) ok = false;
  });
  return ok;
}

/* Die Bezeichnungen der Bestellzeile kommen aus der Vorlage (key je Feld und Auswahl), siehe _hinweis_keys dort. */
function cartPayload() {
  const s = currentSize();
  const frame = TEMPLATE.frames.find((x) => x.id === state.frame);
  const properties = {};
  // Auswahlen (z. B. Spruch) stehen wie bei Globo vor den zugehörigen Freitextfeldern.
  // Felder mit automatischem Wert (Ort und Koordinaten von der Karte) tragen diesen, wenn nichts Eigenes eingegeben ist.
  const valueOf = (f) => typedValue(f) || (f.auto && !f.autoExample && f.autoValue) || '';
  TEMPLATE.fields.filter((f) => !f.showIf && !f.cartHidden).forEach((f) => {
    properties[f.key] = valueOf(f);
    // Direkt hinter dem Ort stehen die gefundenen Koordinaten: daraus macht die 1-Click-App die Karte für den Druck.
    if (TEMPLATE.map && f.key === TEMPLATE.map.field && mapState.found) properties[TEMPLATE.map.coordsKey] = `${mapState.lat.toFixed(6)}, ${mapState.lon.toFixed(6)}`;
  });
  TEMPLATE.choices.forEach((c) => {
    const picked = c.options.find((o) => o.id === state.choices[c.key]);
    // valueFrom: Bei dieser Auswahl steht der eingegebene Text selbst im Feld (so liest ihn die 1-Click-App).
    properties[c.key] = picked.valueFrom ? typedValue(TEMPLATE.fields.find((f) => f.key === picked.valueFrom)) : picked.value;
    TEMPLATE.fields.filter((f) => f.showIf && f.showIf.choice === c.key && isShown(f) && typedValue(f) && !f.cartHidden).forEach((f) => { properties[f.key] = typedValue(f); });
  });
  // Der Schlüssel für den Rahmen heißt je Produkt anders, bei manchen sogar je Größe (frameKeys).
  properties[(TEMPLATE.frameKeys && TEMPLATE.frameKeys[s.id]) || 'Bilderrahmen'] = frame.value;
  if (state.hook) properties[TEMPLATE.hook.key] = TEMPLATE.hook.value;
  const items = [{ artikel: `${TEMPLATE.cartTitle} – ${s.label} (${s.sub})`, preis: s.price, properties }];
  if (state.frame !== 'ohne') {
    items.push({ artikel: `Bilderrahmen – ${frame.label.replace('Holzrahmen ', '')} – ${s.frameLabel}`, preis: s.framePrice });
    if (state.pp) items.push({ artikel: 'Passepartout (Rahmeneinlage)', preis: ppPrice() });
    if (state.hook) items.push({ artikel: TEMPLATE.hook.cartTitle, preis: TEMPLATE.hook.price });
  }
  state.cards.forEach((i) => items.push({ artikel: `Geschenkkarte ${CARDS[i].note}`, preis: CARDS[i].price }));
  return { positionen: items, summe: Number(total().toFixed(2)) };
}

/*
 Vorschau-Schutz: kein Kontextmenü ("Bild speichern unter") und kein Herausziehen auf Vorschau, Produktbild und
 den kleinen Passepartout-Kacheln. Ein Bildschirmfoto verhindert das nicht, deshalb liegen die Motive ohnehin nur in
 Vorschau-Auflösung vor.
*/
['contextmenu', 'dragstart'].forEach((type) => ROOT.addEventListener(type, (e) => {
  if (e.target.closest('.preview, .page img, .swatch--live, #page-image')) e.preventDefault();
}));

/*
 Große Vorschau für die Bildchen von Bilderhaken und Geschenkkarte. Tippen aufs Bildchen öffnet sie (ohne den Haken
 zu setzen), Tippen irgendwo oder Escape schließt sie wieder.
*/
const zoom = document.createElement('div');
zoom.className = 'zoom';
zoom.hidden = true;
zoom.innerHTML = '<img alt=""><button type="button" aria-label="Schließen"><svg viewBox=\"0 0 16 16\" width=\"14\" height=\"14\" aria-hidden=\"true\"><path d=\"M3.5 3.5l9 9M12.5 3.5l-9 9\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\"/></svg></button>';
$('overlay').appendChild(zoom);
zoom.addEventListener('click', () => { zoom.hidden = true; });
document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !zoom.hidden) { e.stopImmediatePropagation(); zoom.hidden = true; } }, true);
function zoomable(img, source) {
  img.addEventListener('click', (e) => {
    e.stopPropagation();
    zoom.querySelector('img').src = source();
    zoom.hidden = false;
  });
}

/*
 Vergrößerte Vorschau: nur das Poster im Rahmen (#svg) wird verschoben und vergrößert, der Rahmen schneidet ab.
 view.s = Faktor, view.x/y = Verschiebung in Bildschirmpunkten, gemessen am unvergrößerten Poster.
*/
const view = { s: 1, x: 0, y: 0 };
function applyView(animate) {
  const svg = $('svg');
  svg.classList.toggle('svg--pinch', !animate);
  svg.style.transform = view.s === 1 ? '' : `translate(${view.x}px, ${view.y}px) scale(${view.s})`;
}
function clampView() {
  const mat = ROOT.querySelector('#frame .mat');
  const w = mat.clientWidth, h = mat.clientHeight;
  view.s = Math.min(4, Math.max(1, view.s));
  view.x = Math.min(0, Math.max(w - view.s * w, view.x));
  view.y = Math.min(0, Math.max(h - view.s * h, view.y));
}
function resetView(animate) { Object.assign(view, { s: 1, x: 0, y: 0 }); applyView(animate); }

/*
 Fokus beim Tippen (Handy): Die Vorschau rückt auf die Zeile, in die gerade geschrieben wird, und vergrößert sie,
 sonst ist z. B. der Name auf dem Definitionsposter kaum zu lesen. Gesucht werden die Textzeile des Feldes und alle
 zusammengesetzten Zeilen, in denen das Feld vorkommt ({Name}).
*/
const phoneQuery = window.matchMedia('(max-width: 760px)');
let focusedField = null;
let focusTimer = null;
function fieldOf(input) { return input && TEMPLATE && TEMPLATE.fields.find((f) => f.el && f.el.contains(input)); }
function focusField(f) {
  if (!f || !phoneQuery.matches || !$('overlay').classList.contains('open')) return;
  const nodes = [];
  if (f.text && f.text.textContent.trim() && f.text.style.display !== 'none') nodes.push(f.text);
  (TEMPLATE.lines || []).forEach((L) => {
    if (L.el && L.el.style.display !== 'none' && (L.text.includes(`{${f.key}}`) || L.text.includes(`{${f.key}|`))) nodes.push(L.el);
  });
  if (!nodes.length) return;
  const mat = ROOT.querySelector('#frame .mat').getBoundingClientRect();
  let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
  nodes.forEach((n) => {
    const r = n.getBoundingClientRect();
    if (!r.width && !r.height) return;
    // Zurückrechnen auf das unvergrößerte Poster.
    x0 = Math.min(x0, (r.left - mat.left - view.x) / view.s); x1 = Math.max(x1, (r.right - mat.left - view.x) / view.s);
    y0 = Math.min(y0, (r.top - mat.top - view.y) / view.s); y1 = Math.max(y1, (r.bottom - mat.top - view.y) / view.s);
  });
  if (!isFinite(x0)) return;
  const w = mat.width, h = mat.height;
  const k = Math.min(3, (w * 0.9) / Math.max(1, x1 - x0), (h * 0.4) / Math.max(1, y1 - y0));
  if (k < 1.2) { resetView(true); return; }
  Object.assign(view, { s: k, x: w / 2 - k * (x0 + x1) / 2, y: h / 2 - k * (y0 + y1) / 2 });
  clampView();
  applyView(true);
}
ROOT.addEventListener('focusin', (e) => {
  const f = fieldOf(e.target);
  if (!f) return;
  focusedField = f;
  // Erst wenn die Tastatur steht und das Fenster sich angepasst hat.
  clearTimeout(focusTimer); focusTimer = setTimeout(() => focusField(f), 450);
});
ROOT.addEventListener('input', (e) => {
  const f = fieldOf(e.target);
  if (f) { clearTimeout(focusTimer); focusTimer = setTimeout(() => focusField(f), 250); }
});
ROOT.addEventListener('focusout', () => setTimeout(() => {
  if (fieldOf(ROOT.activeElement)) return;
  focusedField = null;
  resetView(true);
}, 120));

/*
 Große Vorschau statt Zoomen mit zwei Fingern (das sah aus, als verschiebe man den Druck im Rahmen): Antippen der
 Vorschau zeigt sie bildschirmfüllend, Antippen oder das Kreuz schließt sie. Beim Foto-Motiv zählt Ziehen nicht als Tippen.
*/
const wrap = ROOT.querySelector('.frame-wrap');
wrap.insertAdjacentHTML('beforeend', '<span class="preview__lupe"></span>');
ROOT.querySelector('.preview').insertAdjacentHTML('beforeend', '<button type="button" class="preview__zu" aria-label="Große Vorschau schließen"><svg viewBox=\"0 0 16 16\" width=\"14\" height=\"14\" aria-hidden=\"true\"><path d=\"M3.5 3.5l9 9M12.5 3.5l-9 9\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\"/></svg></button>');
let tapStart = null;
wrap.addEventListener('pointerdown', (e) => { tapStart = [e.clientX, e.clientY]; });
function showLarge(on) {
  ROOT.querySelector('.preview').classList.toggle('preview--gross', on);
  if (on) resetView(false);
}
wrap.addEventListener('click', (e) => {
  if (tapStart && Math.hypot(e.clientX - tapStart[0], e.clientY - tapStart[1]) > 6) return;
  showLarge(!ROOT.querySelector('.preview').classList.contains('preview--gross'));
});
ROOT.querySelector('.preview__zu').addEventListener('click', () => showLarge(false));
// In der großen Vorschau schließt ein Tippen irgendwo (auch auf den Rand neben dem Poster), damit niemand festhängt.
ROOT.querySelector('.preview').addEventListener('click', (e) => {
  if (ROOT.querySelector('.preview--gross') && !wrap.contains(e.target)) showLarge(false);
});
document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && ROOT.querySelector('.preview--gross')) { e.stopImmediatePropagation(); showLarge(false); } }, true);
// Ändert sich die Größe der Vorschau (Tastatur, Drehen), passt die alte Verschiebung nicht mehr.
new ResizeObserver(() => { if (focusedField) focusField(focusedField); else if (view.s !== 1) resetView(false); }).observe(ROOT.querySelector('#frame .mat'));

/* Letzte Prüfung: alle Eingaben so, wie sie gedruckt werden. "Passt" legt in den Warenkorb, "Ändern" schließt. */
let reviewed = false;
const review = document.createElement('div');
review.className = 'review';
review.hidden = true;
review.innerHTML = '<div class="review__box" role="dialog" aria-modal="true" aria-label="Deine Angaben prüfen"><h3>So drucken wir dein Poster</h3>'
  + '<p>Wir drucken genau so, wie du es eingegeben hast. Bitte prüfe Schreibweise, Namen und Daten.</p><dl></dl>'
  + '<div class="review__buttons"><button type="button" class="btn" data-ok>In den Warenkorb legen</button><button type="button" class="btn btn--ghost" data-edit>Ändern</button></div></div>';
$('overlay').appendChild(review);
review.addEventListener('click', (e) => { if (e.target === review) review.hidden = true; });
review.querySelector('[data-edit]').addEventListener('click', () => { review.hidden = true; });
review.querySelector('[data-ok]').addEventListener('click', () => { review.hidden = true; reviewed = true; $('add').click(); });
document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !review.hidden) { e.stopImmediatePropagation(); review.hidden = true; } }, true);
function showReview() {
  const props = cartPayload().positionen[0].properties;
  const dl = review.querySelector('dl');
  dl.replaceChildren();
  const row = (k, v) => { const dt = document.createElement('dt'); dt.textContent = k; const dd = document.createElement('dd'); dd.textContent = v; dl.append(dt, dd); };
  row('Postergröße', `${currentSize().label} (${currentSize().sub})`);
  Object.keys(props).forEach((k) => {
    const v = props[k];
    if (k.charAt(0) === '_' || v == null || v === '' || typeof v !== 'string') return;
    row(k, v);
  });
  if (TEMPLATE.photo) row('Foto', photo.file ? 'hochgeladen' : 'noch keins');
  review.hidden = false;
}

function openWindow() {
  // Set-Modus oder Serien-Auswahl der Produktseite: mehrere Poster in einem Fenster (sonst wie bisher ein Poster).
  if (TEMPLATE) setupMulti(multiMode());
  // Im Shop gilt die Größe, die auf der Produktseite gerade gewählt ist.
  if (ENV.currentSize && TEMPLATE) { state.size = ENV.currentSize() || state.size; render(); }
  else if (TEMPLATE && multi.kind) render();
  $('overlay').classList.add('open'); lockPage(true); fitPreviewLead(); renderNames(); fitViewport();
  // Vorlagen mit Karte: solange kein Ort eingegeben ist, eine blasse Beispielkarte zeigen.
  // Mit festem Beispielbild (ex.image) geht beim Öffnen nichts an den Kartendienst, erst wenn der Kunde einen Ort sucht.
  if (TEMPLATE && TEMPLATE.map && TEMPLATE.map.example && !mapState.found && !mapState.map && !mapState.exampleShown) {
    const ex = TEMPLATE.map.example;
    mapState.exampleShown = true;
    if (ex.image) showMapImage(asset(ex.image), ex.lat, ex.lon, ex.city, true);
    else showMap(ex.lat, ex.lon, ex.city, true, mapState.token).catch((error) => console.error(error));
  }
  // Tastatur: Fokus ins Fenster (Schließen-Knopf), beim Schließen zurück auf den Knopf der Produktseite.
  setTimeout(() => { const c = $('close'); if (c) c.focus({ preventScroll: true }); }, 0);
}
$('open').addEventListener('click', openWindow);
// Im Shop meldet das Theme, wenn auf der Produktseite eine andere Größe gewählt wurde (Rahmenpreise der Kacheln).
ENV.sync = () => { if (!TEMPLATE) return; state.size = (ENV.currentSize && ENV.currentSize()) || state.size; render(); };
// Theme: Fenster nach dem Hinzufügen schließen (der Warenkorb öffnet dann als Seitenleiste).
ENV.close = () => closeWindow();
/*
 Theme: Angaben einer Warenkorbzeile wieder ins Fenster laden ("Ändern" im Warenkorb, Johannes 21.10.2026). Wartet, bis
 die Vorlage steht. Felder und Auswahlen über ihren key wie in cartPayload, ein eigener Text landet wieder in seinem
 Feld (valueFrom). Der Ort sucht die Karte neu, die Zeile darunter behält den gespeicherten Text.
*/
ENV.prefill = (props) => los().then(() => {
  const setze = (f, v) => {
    if (!f || f.kind === 'foto' || v == null) return;
    state.values[f.key] = String(v);
    const input = f.el && f.el.querySelector('input');
    if (input) { input.value = String(v); f.lastAuto = null; const zahl = f.el.querySelector('b i'); if (zahl) zahl.textContent = `${input.value.length}/${f.max}`; }
  };
  TEMPLATE.fields.forEach((f) => setze(f, props[f.key]));
  TEMPLATE.choices.forEach((c) => {
    const v = props[c.key];
    if (v == null) return;
    let o = c.options.find((x) => !x.valueFrom && x.value === v);
    if (!o) { o = c.options.find((x) => x.valueFrom); if (o) setze(TEMPLATE.fields.find((f) => f.key === o.valueFrom), v); }
    if (o) state.choices[c.key] = o.id;
  });
  if (props['Passepartout (Rahmeneinlage)']) state.pp = true;
  if (TEMPLATE.hook && props[TEMPLATE.hook.key]) state.hook = true;
  const ort = TEMPLATE.fields.find((f) => f.kind === 'ort' && typedValue(f));
  if (ort) locate(ort);
  render();
  renderNames();
});
$('hook').addEventListener('click', () => { state.hook = !state.hook; render(); });
$('hook-minus').addEventListener('click', () => { const n = multiLines().length; multi.hookPacks = Math.max(1, hookPacks(n) - 1); render(); });
$('hook-plus').addEventListener('click', () => { const n = multiLines().length; multi.hookPacks = hookPacks(n) + 1; render(); });
// "Als Set ansehen": Produktseite auf "Als Set" umstellen und das offene Fenster in den Set-Modus schalten.
$('set-hint-link').addEventListener('click', () => {
  const G = gruppe();
  if (!G || !G.set) return;
  if (G.setzeSetModus) G.setzeSetModus(true);
  G.setModus = true;
  setupMulti('set');
  render();
  ROOT.querySelector('.options').scrollTop = 0;
});
// Die Vorschau mit mehreren Postern ordnet sich bei jeder Größenänderung neu an.
new ResizeObserver(() => layoutWall()).observe($('wall'));
/* Schließen, von allen Stellen gleich. Die Eingaben bleiben stehen: erneut öffnen und einfach weitermachen. */
function closeWindow() {
  const wasOpen = $('overlay').classList.contains('open');
  $('overlay').classList.remove('open');
  if (wasOpen) setTimeout(() => { const o = (ENV.opener && ENV.opener()) || $('open'); if (o) o.focus({ preventScroll: true }); }, 0);
  ROOT.querySelector('.preview').classList.remove('preview--gross');
  lockPage(false);
  resetView(true);
  // Zurück auf der Produktseite gilt wieder deren Größe (sonst zeigen die Rahmen-Kacheln den Aufpreis der Größe aus dem Fenster).
  if (wasOpen && TEMPLATE && ENV.currentSize && !multi.kind) { state.size = ENV.currentSize() || state.size; render(); }
}
// Solange das Fenster offen ist, scrollt die Seite dahinter nicht mit.
let lockedY = 0;
function lockPage(on) {
  const b = document.body.style;
  if (on && b.position !== 'fixed') {
    lockedY = window.scrollY;
    Object.assign(b, { position: 'fixed', top: `-${lockedY}px`, left: '0', right: '0', width: '100%' });
  } else if (!on && b.position === 'fixed') {
    Object.assign(b, { position: '', top: '', left: '', right: '', width: '' });
    window.scrollTo(0, lockedY);
  }
  document.documentElement.style.overflow = on ? 'hidden' : '';
}
/*
 Handy: Wischen auf der Vorschau oder sonst außerhalb der Eingabespalte darf weder die Seite dahinter noch die
 Vorschau bewegen. Gescrollt wird nur in den Eingaben (.options) und in der Prüfungs-Übersicht.
*/
let touchY = null;
$('overlay').addEventListener('touchstart', (e) => { touchY = e.touches[0] ? e.touches[0].clientY : null; }, { passive: true });
$('overlay').addEventListener('touchmove', (e) => {
  if (e.target.closest && e.target.closest('.options, .review__box')) return;
  e.preventDefault();
  // Wer neben den Eingaben wischt (z. B. auf der Vorschau), scrollt trotzdem ganz normal die Eingaben.
  // Ausnahme: das Foto, das gerade mit dem Finger verschoben wird.
  if (TEMPLATE && TEMPLATE.photo && photo.img && e.target.closest && e.target.closest('#svg')) return;
  const y = e.touches[0] ? e.touches[0].clientY : null;
  if (touchY != null && y != null) ROOT.querySelector('.options').scrollTop += touchY - y;
  touchY = y;
}, { passive: false });
// Am Rechner: Mausrad über der Vorschau scrollt ebenfalls die Eingaben.
ROOT.querySelector('.preview').addEventListener('wheel', (e) => {
  if (ROOT.querySelector('.preview--gross')) return;
  ROOT.querySelector('.options').scrollTop += e.deltaY;
  e.preventDefault();
}, { passive: false });
['close', 'back-bottom'].forEach((id) => $(id).addEventListener('click', closeWindow));
$('overlay').addEventListener('click', (e) => { if (e.target === $('overlay')) closeWindow(); });
document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && $('overlay').classList.contains('open')) closeWindow(); });
// Tab bleibt im offenen Fenster (springt vom letzten zum ersten Element und umgekehrt).
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Tab' || !$('overlay').classList.contains('open')) return;
  const list = Array.from($('overlay').querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
    .filter((el) => !el.disabled && el.getClientRects().length && !el.closest('[hidden]'));
  if (!list.length) return;
  const active = (ROOT.activeElement !== undefined ? ROOT.activeElement : null) || document.activeElement;
  const first = list[0], last = list[list.length - 1];
  if (!list.includes(active)) { e.preventDefault(); first.focus(); }
  else if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
});
// Safari zoomt sonst trotz touch-action die ganze Seite.
document.addEventListener('gesturestart', (e) => { if ($('overlay').classList.contains('open')) e.preventDefault(); });
$('add').addEventListener('click', () => {
  if (!validate()) return;
  // Personalisierte Poster: erst die Übersicht "So drucken wir dein Poster", der Knopf dort legt dann in den Warenkorb.
  if (TEMPLATE.fields.length && !reviewed) { showReview(); return; }
  reviewed = false;
  // Mehrere Poster: je Poster dieselben Zeilen wie beim einzelnen Poster, alles in einem Aufruf (Theme: onAddMulti).
  if (multi.kind && ENV.onAddMulti) {
    const frame = TEMPLATE.frames.find((x) => x.id === state.frame);
    const hook = state.frame !== 'ohne' && state.hook;
    const G = gruppe();
    const packs = hook ? hookPacks(multiLines().length) : 0;
    const posters = multiLines().map((l, i) => {
      const frameKey = (TEMPLATE.frameKeys && TEMPLATE.frameKeys[l.size]) || 'Bilderrahmen';
      const properties = { [frameKey]: frame.value };
      // Die Haken hängen als eine Zeile am ersten Poster, mit der gewählten Anzahl Päckchen.
      if (hook && i === 0) properties[TEMPLATE.hook.key] = `Bilderhaken (${packs * 2} Stück)`;
      return { handle: l.p.h, title: l.p.t, variants: l.p.variants, size: l.size, passepartout: l.ppOk, frameKey, properties };
    });
    ENV.onAddMulti({ posters, frame: state.frame, hook, hookPacks: packs, hookKey: TEMPLATE.hook.key, cards: state.cards.slice(), setName: multi.kind === 'set' ? G.set.name : null, summe: multiTotal().sum }, $('add'));
    return;
  }
  // Im Shop übernimmt das Theme den echten Warenkorb. Es bekommt die Auswahl als Daten und die Eigenschaften der Bestellzeile.
  if (ENV.onAdd) {
    const payload = cartPayload();
    const frameKey = (TEMPLATE.frameKeys && TEMPLATE.frameKeys[state.size]) || 'Bilderrahmen';
    const choice = { size: state.size, frame: state.frame, passepartout: state.pp, hook: state.hook, cards: state.cards.slice(), properties: payload.positionen[0].properties, summe: payload.summe, frameKey, hookKey: TEMPLATE.hook.key };
    // Vorlagen mit Foto: der Ausschnitt (so wie gezeigt) und das Original gehen als Dateien an die Bestellzeile.
    if (TEMPLATE.photo && photo.file) {
      $('add').disabled = true;
      photoCrop().then((crop) => {
        const key = TEMPLATE.photo.field;
        delete choice.properties[key];
        choice.files = { [key]: crop, [`${key} Original`]: photo.file };
        ENV.onAdd(choice, $('add'));
      });
      return;
    }
    ENV.onAdd(choice, $('add'));
    return;
  }
  $('result-json').textContent = JSON.stringify(cartPayload(), null, 2);
  $('result').style.display = 'block';
  closeWindow();
  $('result').scrollIntoView({ behavior: 'smooth' });
});

new ResizeObserver(([entry]) => {
  $('frame').style.setProperty('--fw', `${entry.contentRect.width}px`);
  requestAnimationFrame(updatePassepartout);
}).observe($('frame'));

/*
 Handy mit offener Tastatur. Die Tastatur verkleinert nur den sichtbaren Bereich, nicht die Seite: ohne Gegenmaßnahme
 schiebt der Browser das Eingabefeld nach oben und die Vorschau aus dem Bild. Deshalb folgt das Fenster dem sichtbaren
 Bereich (visualViewport): Es ist nur so hoch wie der Platz über der Tastatur, die Vorschau bleibt oben stehen und
 das Feld, in das getippt wird, rückt direkt darunter.
*/
const viewport = window.visualViewport;
let fullHeight = 0;
function layoutViewport(height, top, typing) {
  const overlay = $('overlay'), modal = ROOT.querySelector('.modal');
  const phone = window.matchMedia('(max-width: 760px)').matches;
  /*
   Nur bei offener Tastatur dem sichtbaren Ausschnitt folgen. Ohne Tastatur füllt das Fenster per CSS (100dvh) den
   Bildschirm: sonst übernahm es beim Antippen einer Größe den Ausschnitt, während die Seite noch scrollte, und saß
   dann halb unten (Handytest 14.10.2026).
  */
  const follow = phone && typing;
  overlay.style.top = follow ? `${top}px` : '';
  overlay.style.bottom = follow ? 'auto' : '';
  overlay.style.height = follow ? `${height}px` : '';
  modal.style.height = follow ? `${height}px` : '';
  // Nur beim Öffnen der Tastatur und beim Wechsel des Feldes nachrücken, sonst ließe sich nicht mehr von Hand scrollen.
  const wasTyping = modal.classList.contains('modal--typing');
  modal.classList.toggle('modal--typing', phone && typing);
  if (phone && typing && (!wasTyping || fieldChanged)) showActiveField();
  fieldChanged = false;
}
let fieldChanged = false;
function fitViewport() {
  if (!viewport || !$('overlay').classList.contains('open')) return;
  fullHeight = Math.max(fullHeight, viewport.height);
  // Tastatur gilt als offen, wenn deutlich weniger Höhe sichtbar ist als ohne sie.
  layoutViewport(viewport.height, viewport.offsetTop, viewport.height < fullHeight - 120);
}
/* Rückt das Feld mit dem Cursor an den oberen Rand der Eingabespalte (bei Feldern ohne eigene Beschriftung den Abschnitt). */
function showActiveField() {
  const input = ROOT.activeElement;
  const field = input && input.closest && input.closest('label.field');
  if (!field) return;
  const options = ROOT.querySelector('.options');
  const target = field.classList.contains('field--nolabel') || field.previousElementSibling === field.parentElement.firstElementChild ? field.closest('.group') : field;
  options.scrollTop += target.getBoundingClientRect().top - options.getBoundingClientRect().top - 8;
}
if (viewport) {
  viewport.addEventListener('resize', fitViewport);
  viewport.addEventListener('scroll', fitViewport);
  ROOT.addEventListener('focusin', () => { fieldChanged = true; setTimeout(fitViewport, 60); setTimeout(fitViewport, 400); });
  ROOT.addEventListener('focusout', () => setTimeout(fitViewport, 60));
}

/*
 Im großen Fenster steht die Posterhöhe fest (siehe CSS). Kommt ein Hinweis über das Poster, wird das Poster um
 dessen Höhe kleiner; entfällt dafür der Satz darunter (15 px Zeile + 8 px Abstand), wird das gegengerechnet.
*/
function fitPreviewLead() {
  const lead = $('preview-lead');
  const extra = (lead.hidden ? 0 : lead.offsetHeight + 8) - ($('preview-note').hidden ? 23 : 0) + ($('preview-note-top').hidden ? 0 : 23);
  ROOT.querySelector('.modal').style.setProperty('--extra', `${extra}px`);
}
window.addEventListener('resize', fitPreviewLead);

/* Trägt alles Motivspezifische in die Seite ein, was nicht bei jedem render() neu entsteht. */
function applyTemplate() {
  const [PW, PH] = TEMPLATE.page;
  if (!ENV.root) document.title = `JUHMI Customizer – Prototyp ${TEMPLATE.cartTitle}`;
  $('page-title').textContent = TEMPLATE.title;
  if (TEMPLATE.modalTitle) $('modal-title').textContent = TEMPLATE.modalTitle;
  baseTitle = $('modal-title').textContent;
  // Das Bild im Platzhalter der Produktseite gibt es nur im Prototyp. Im Shop wäre es ein unnötiger Abruf.
  if (!ENV.root) $('page-image').src = asset(TEMPLATE.pageImage || TEMPLATE.image);
  $('page-image').alt = TEMPLATE.imageAlt;
  $('svg').setAttribute('viewBox', `0 0 ${PW} ${PH}`);
  // Querformat: Rahmen, Miniaturen und Fensteraufteilung drehen sich per CSS (.modal--quer).
  ROOT.querySelector('.modal').classList.toggle('modal--quer', PW > PH);
  $('motif').setAttribute('href', asset(TEMPLATE.image));
  // imageBleed: das Bild etwas größer als das Blatt zeigen und am Blattrand abschneiden. Damit verschwindet ein
  // feiner Rand, den manche Produktbilder ringsum haben (sonst als dunkle Linie im Passepartout sichtbar).
  const bleed = TEMPLATE.imageBleed || 0;
  $('motif').setAttribute('x', -bleed * PW);
  $('motif').setAttribute('y', -bleed * PH);
  $('motif').setAttribute('width', PW * (1 + 2 * bleed));
  $('motif').setAttribute('height', PH * (1 + 2 * bleed));
  $('motif').setAttribute('preserveAspectRatio', 'none');
  $('page-clip-rect').setAttribute('width', PW);
  $('page-clip-rect').setAttribute('height', PH);
  if (bleed) $('motif').setAttribute('clip-path', 'url(#page-clip)');
  $('hook-image').src = asset(TEMPLATE.hook.image);
  zoomable($('hook-image'), () => asset(TEMPLATE.hook.image));
  $('hook-label').innerHTML = `${TEMPLATE.hook.label}<small>${TEMPLATE.hook.note}</small>`;
  $('hook-price').textContent = `+ ${euro(TEMPLATE.hook.price)}`;
  CARDS.forEach((card, i) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'extra';
    button.innerHTML = `<span class="extra__box"></span><span class="extra__thumb"><img alt=""><span class="extra__lupe"></span></span><span class="extra__text">${card.label}<small>${card.note}</small></span><span class="extra__price">+ ${euro(card.price)}</span>`;
    button.querySelector('img').src = card.image;
    // Groß: eigenes größeres Bild aus dem Shop (zoom), sonst das kleine.
    zoomable(button.querySelector('img'), () => card.zoom || card.image);
    button.addEventListener('click', () => { state.cards = state.cards.includes(i) ? state.cards.filter((x) => x !== i) : state.cards.concat(i); render(); });
    $('card-group').appendChild(button);
  });
  centerY = PH / 2;
  state.size = TEMPLATE.defaultSize;
  // Einstieg über einen Link auf eine Rahmen-Variante (z. B. Google Shopping "A4 / Schwarz"): diesen Rahmen
  // vorauswählen. Nur einmal beim Laden, danach gilt, was der Kunde wählt.
  const startFrame = ENV.startFrame && ENV.startFrame();
  if (startFrame && TEMPLATE.frames.some((x) => x.id === startFrame)) state.frame = startFrame;
  // Hinweis über dem Poster und der kleine Satz darunter sind je Vorlage einstellbar.
  $('preview-lead').hidden = !TEMPLATE.previewLead;
  // Der Hinweis stammt aus der eigenen Vorlage und darf Auszeichnung enthalten (z. B. <u> für Unterstreichung).
  $('preview-lead').innerHTML = `<span>${TEMPLATE.previewLead || ''}</span>`;
  $('preview-note').hidden = Boolean(TEMPLATE.hidePreviewNote);
  if (TEMPLATE.previewNote) $('preview-note').textContent = TEMPLATE.previewNote;
  // Zweiter kleiner Satz über dem Poster (previewNoteAbove), im selben leisen Stil.
  $('preview-note-top').hidden = !TEMPLATE.previewNoteAbove;
  $('preview-note-top').textContent = TEMPLATE.previewNoteAbove || '';
  // Rahmenkacheln auf der Produktseite nur bei Postern ohne Personalisierung (pageFrames in der Vorlage).
  $('page-frames-group').hidden = !TEMPLATE.pageFrames;
  // Hinweis zum Druck nur bei Postern mit Eingaben.
  $('print-note').hidden = !TEMPLATE.fields.length;
  // Farbfläche hinter dem Motiv (panel = Name der Auswahl): Farbe und Fläche kommen von der gewählten Kachel.
  // Das Motivbild (dunkle Zeichnung auf Weiß) wird darüber multipliziert, das Weiß verschwindet also.
  if (TEMPLATE.panel) {
    $('map-layer').innerHTML = '<rect id="panel-rect"/>';
    $('motif').style.mixBlendMode = 'multiply';
  }
  // Fotofläche: heller Platzhalter mit Hinweis, darüber später das Foto, beschnitten auf die Fläche. Das Motivbild
  // (Text auf Weiß) wird darüber multipliziert.
  if (TEMPLATE.photo) {
    const [x0, y0, x1, y1] = TEMPLATE.photo.box;
    $('map-layer').innerHTML = `<clipPath id="foto-clip"><rect x="${x0}" y="${y0}" width="${x1 - x0}" height="${y1 - y0}"/></clipPath>`
      + `<rect x="${x0}" y="${y0}" width="${x1 - x0}" height="${y1 - y0}" fill="#ecebe7"/>`
      + `<text id="foto-hint" x="${(x0 + x1) / 2}" y="${(y0 + y1) / 2}" text-anchor="middle" font-family="-apple-system, Helvetica, Arial, sans-serif" font-size="150" fill="#a8a49d">Dein Foto</text>`
      + `<image id="foto-image" clip-path="url(#foto-clip)" preserveAspectRatio="none"/>`;
    $('motif').style.mixBlendMode = 'multiply';
    ROOT.querySelector('.preview').classList.add('preview--foto');
    // Ausschnitt verschieben: Weg des Fingers oder der Maus in Seitenpixel umrechnen.
    const svg = $('svg');
    let last = null;
    svg.addEventListener('pointerdown', (e) => { if (photo.img) { last = [e.clientX, e.clientY]; svg.setPointerCapture(e.pointerId); } });
    svg.addEventListener('pointermove', (e) => {
      if (!last) return;
      const perPx = TEMPLATE.page[0] / svg.getBoundingClientRect().width / ((window.__layout && window.__layout.scale) || 1);
      const p = photoPlacement();
      photo.cx -= (e.clientX - last[0]) * perPx / p.w;
      photo.cy -= (e.clientY - last[1]) * perPx / p.h;
      last = [e.clientX, e.clientY];
      renderPhoto();
    });
    ['pointerup', 'pointercancel'].forEach((type) => svg.addEventListener(type, () => { last = null; }));
  }
  // Karte: graue Fläche in Form der Hände, darüber später das Kartenbild, beides auf die Maske beschnitten.
  if (TEMPLATE.map) {
    const m = TEMPLATE.map;
    const w = Math.round((m.area[2] - m.area[0]) / m.pagePxPerMapPx) * m.pagePxPerMapPx, h = Math.round((m.area[3] - m.area[1]) / m.pagePxPerMapPx) * m.pagePxPerMapPx;
    $('map-mask').setAttribute('width', PW); $('map-mask').setAttribute('height', PH);
    $('map-mask-image').setAttribute('href', asset(m.mask));
    $('map-mask-image').setAttribute('width', PW); $('map-mask-image').setAttribute('height', PH);
    $('map-layer').setAttribute('mask', 'url(#map-mask)');
    $('map-layer').innerHTML = `<rect x="0" y="0" width="${PW}" height="${PH}" fill="${m.fill}"/>`
      + `<image id="map-image" x="${m.center[0] - w / 2}" y="${m.center[1] - h / 2}" width="${w}" height="${h}" preserveAspectRatio="none"/>`;
  }
}

async function start() {
  TEMPLATE = await loadTemplate(TEMPLATE_NAME);
  applyTemplate();
  if (TEMPLATE.placement && TEMPLATE.placement.table) {
    const table = await loadJson(TEMPLATE.placement.table);
    table.positions.forEach((p) => { CALIBRATION[`${p.position}${p.letter}`] = { x: p.x, y: p.y }; });
  }
  const fonts = new Set(TEMPLATE.fields.map((f) => (f.kind === 'handname' ? f.fallback.font : f.font || TEMPLATE.fontFamily)));
  TEMPLATE.choices.forEach((c) => c.options.forEach((o) => { if (o.line) fonts.add(o.line.font); }));
  (TEMPLATE.lines || []).forEach((L) => fonts.add(`${L.weight || 400} 100px "${L.font}"`));
  if (TEMPLATE.calendar) fonts.add(`400 100px "${TEMPLATE.calendar.font}"`);
  await Promise.all([...fonts].map((font) => document.fonts.load(/px /.test(font) ? font : `100px "${font}"`)));
  buildSections();
  render();
  renderNames();
}
/*
 Start erst, wenn der Browser nach dem Laden Luft hat oder der Kunde etwas tut (Tippen, Klicken, Taste). Vorher kostete der
 Start beim Laden der Produktseite rund 200 ms Rechenzeit (Agententest 17.10.2026). Wird das Fenster geöffnet, bevor die
 Vorlage fertig ist, zieht es nach dem Start Größe und Set-Auswahl nach.
*/
let gestartet = null;
function los() {
  if (gestartet) return gestartet;
  gestartet = start().then(() => {
    // Größe der Produktseite übernehmen, auch bei geschlossenem Fenster: die Rahmen-Kacheln der Seite zeigen sonst
    // beim Aufruf über einen Varianten-Link den Aufpreis der Startgröße (Agententest 20.10.2026).
    if (ENV.currentSize) state.size = ENV.currentSize() || state.size;
    if (!$('overlay').classList.contains('open')) { render(); return; }
    setupMulti(multiMode());
    render(); renderNames();
  }).catch((err) => {
    // Fehlende oder fehlerhafte Vorlage: lieber eine klare Meldung als eine leere Seite.
    $('page-title').textContent = `Vorlage "${TEMPLATE_NAME}" konnte nicht geladen werden`;
    $('open').disabled = true;
    console.error(err);
  });
  return gestartet;
}
['pointerdown', 'touchstart', 'keydown', 'focusin'].forEach((typ) => document.addEventListener(typ, los, { capture: true, passive: true, once: true }));
const losNachLaden = () => { if ('requestIdleCallback' in window) requestIdleCallback(los, { timeout: 3000 }); else setTimeout(los, 1500); };
if (document.readyState === 'complete') losNachLaden(); else window.addEventListener('load', losNachLaden, { once: true });

})();
